export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type AcceptBidInput = {
  bid_id: Scalars['ID']['input'];
  deal_id: Scalars['ID']['input'];
};

/** Per-account list of remittance records (all months, month-ascending). */
export type AccountRemittanceRecords = {
  account_id: Scalars['ID']['output'];
  records: Array<RemittanceRecord>;
};

/** Variances for a single account. */
export type AccountRemittanceVariances = {
  account_id: Scalars['String']['output'];
  variances: Array<RemittanceRecordVariance>;
};

export type AddCollateralNoteInput = {
  authorRole: DealMessageAuthorRole;
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  loanID: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

/** Add a remittance note for a given account (remittance account id). */
export type AddRemittanceNoteInput = {
  accountID: Scalars['ID']['input'];
  buyerCompanyID: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  offeringID: Scalars['ID']['input'];
};

export type AddWireDetailsNoteInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export enum Agency {
  FDIC = 'FDIC',
  NCUA = 'NCUA',
  NONE = 'NONE'
}

/** Input for approving a remittance tape upload. Only the deal seller may approve; upload must be PENDING. */
export type ApproveRemittanceRecordsInput = {
  /** ID of the remittance upload to approve */
  upload_id: Scalars['ID']['input'];
};

/** Result for a single archived/restored loan tape */
export type ArchiveLoanTapeResult = {
  /** Optional message about the operation (e.g. why it was skipped) */
  message?: Maybe<Scalars['String']['output']>;
  /** Success status of the archive/restore operation */
  success: Scalars['Boolean']['output'];
  /** ID of the loan tape */
  tape_id: Scalars['ID']['output'];
};

/** Input for archiving multiple loan tapes */
export type ArchiveLoanTapesInput = {
  /** IDs of the loan tapes (File records) to archive */
  tape_ids: Array<Scalars['ID']['input']>;
};

/** Response from archiving or restoring loan tapes */
export type ArchiveLoanTapesResponse = {
  /** Optional summary message about the operation */
  message?: Maybe<Scalars['String']['output']>;
  /** Per-tape result */
  results: Array<ArchiveLoanTapeResult>;
  /** True only when every tape in the request succeeded */
  success: Scalars['Boolean']['output'];
};

/** Input for archiving multiple pools */
export type ArchivePoolsInput = {
  /** IDs of the pools to archive */
  pool_ids: Array<Scalars['ID']['input']>;
};

/** Response from archiving multiple pools */
export type ArchivePoolsResponse = {
  /** Optional message about the operation */
  message?: Maybe<Scalars['String']['output']>;
  /** Results for each pool */
  results: Array<ArchivePoolsResult>;
  /** Success status of the archive operation */
  success: Scalars['Boolean']['output'];
};

/** Result for a single archived pool */
export type ArchivePoolsResult = {
  /** Optional message about the operation */
  message?: Maybe<Scalars['String']['output']>;
  /** ID of the pool */
  pool_id: Scalars['ID']['output'];
  /** Success status of the archive operation */
  success: Scalars['Boolean']['output'];
};

export enum AssetClass {
  AIRCRAFT = 'AIRCRAFT',
  AUTO = 'AUTO',
  BOAT = 'BOAT',
  CRE = 'CRE',
  HELOC = 'HELOC',
  HOME = 'HOME',
  MARINE = 'MARINE',
  MBL = 'MBL',
  MOTORCYCLE = 'MOTORCYCLE',
  REVOLVING = 'REVOLVING',
  RV = 'RV',
  SOLAR = 'SOLAR',
  UNSECPERSONAL = 'UNSECPERSONAL',
  WAREHOUSE = 'WAREHOUSE'
}

/** Auth Result */
export type AuthResult = {
  accessToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type AutoLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  /** AutoLoan specific */
  auto_original_value_cents?: Maybe<Scalars['Long']['output']>;
  auto_vin?: Maybe<Scalars['String']['output']>;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  /** Secured Consumer loan fields (integer bps, e.g. 8000 = 80%) */
  city?: Maybe<Scalars['String']['output']>;
  company: PrivateCompany;
  cra?: Maybe<Scalars['Boolean']['output']>;
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  /** ConsumerLoan specific (integer bps); null for asset-depletion loans (ENG-3391) */
  dti_bps?: Maybe<Scalars['Int']['output']>;
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  /** ConsumerLoan implemented fields */
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months: Scalars['Int']['output'];
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date: Scalars['DateTime']['output'];
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date: Scalars['DateTime']['output'];
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  postal_code?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  property_year?: Maybe<Scalars['Int']['output']>;
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  /** ASSET_UTIL when the tape's asset_based_decision flag was truthy (ENG-3391) */
  underwriting_type?: Maybe<UnderwritingType>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type AutoMapFieldsInput = {
  columns: Array<Scalars['String']['input']>;
  enums: Array<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  /** This is ignored. It is only here for backwards compatibility. */
  sampleRows?: InputMaybe<Array<InputMaybe<Array<Scalars['String']['input']>>>>;
};

export type AutoMapFieldsResult = {
  errors?: Maybe<Error>;
  matches?: Maybe<Array<Maybe<Match>>>;
};

export type Bid = {
  bid_id: Scalars['ID']['output'];
  carve?: Maybe<Array<ExistingFilter>>;
  carve_summary?: Maybe<PerformanceSummary>;
  price?: Maybe<Price>;
  seller_bid_basis_points?: Maybe<Scalars['Int']['output']>;
  stipulations?: Maybe<Stipulations>;
  terms?: Maybe<Array<TermsDocument>>;
};

export type BidCard = TimelineCard & {
  /** BidCard Fields */
  asset_class: AssetClass;
  bid: Bid;
  /** Returns all bids and counterbids for this deal, with information about which side (buyer or seller) submitted each bid */
  bids: Array<DealBid>;
  can_edit_counteroffer: Scalars['Boolean']['output'];
  carve_criteria_section: Scalars['Boolean']['output'];
  carve_summary?: Maybe<PerformanceSummary>;
  counteroffer_details_section: Scalars['Boolean']['output'];
  deal: Deal;
  documents: Array<TermsDocument>;
  is_participation_negotiable?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date: Scalars['DateTime']['output'];
  participation_rate?: Maybe<Scalars['Int']['output']>;
  role: DealRole;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
  upb_criteria_section: Scalars['Boolean']['output'];
};

export enum BidStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type Borrower = {
  guarantors: Array<Guarantor>;
  name: Scalars['String']['output'];
  revolving_debt_cents?: Maybe<Scalars['Long']['output']>;
  summary: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  /** BusinessLoan Fields */
  amortization_term_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  borrower: Borrower;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** CRELoan specific fields */
  collateral: Collateral;
  company: PrivateCompany;
  cra?: Maybe<Scalars['Boolean']['output']>;
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  future_advance_cents: Scalars['Long']['output'];
  /** Loan fields */
  id: Scalars['ID']['output'];
  initial_advance_cents: Scalars['Long']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months?: Maybe<Scalars['Int']['output']>;
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date?: Maybe<Scalars['DateTime']['output']>;
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date?: Maybe<Scalars['DateTime']['output']>;
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  product?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  property_year: Scalars['Int']['output'];
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  total_commitment_cents: Scalars['Long']['output'];
  version?: Maybe<Scalars['Long']['output']>;
};

export type CalculateBidPriceInput = {
  bid_basis_points: Scalars['Float']['input'];
  carve?: InputMaybe<Array<Filter>>;
  deal_id: Scalars['ID']['input'];
  transfer_amount?: InputMaybe<Scalars['Int']['input']>;
};

export type CallToAction = {
  card: TimelineCard;
  title: Scalars['String']['output'];
};

export type CarveDetailsCard = TimelineCard & {
  /** CarveDetailsCard Fields */
  asset_class: AssetClass;
  /** @deprecated We dont need this field anymore */
  can_edit_carve: Scalars['Boolean']['output'];
  /** @deprecated Use carve_summary instead */
  carve_criteria_section: Scalars['Boolean']['output'];
  /** If the seller uses this api, they must provide a bid_id. If the buyer uses this, it will return all carves. bid_id is returned in graphql type Bid as bid_id */
  carves?: Maybe<Array<DealCarve>>;
  deal: Deal;
  deal_performance_summary: PerformanceSummary;
  last_updated_date: Scalars['DateTime']['output'];
  role: DealRole;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
  /** @deprecated Use carve_summary instead */
  upb_criteria_section: Scalars['Boolean']['output'];
};


export type CarveDetailsCardCarvesArgs = {
  bid_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CashFlowMonth = {
  cash_flow_cents: Scalars['Long']['output'];
  defaults_cents: Scalars['Long']['output'];
  ending_balance_cents: Scalars['Long']['output'];
  interest_cents: Scalars['Long']['output'];
  losses_cents: Scalars['Long']['output'];
  month: Scalars['Int']['output'];
  payments_cents: Scalars['Long']['output'];
  prepayments_cents: Scalars['Long']['output'];
  principal_cents: Scalars['Long']['output'];
  servicing_cents: Scalars['Long']['output'];
  starting_balance_cents: Scalars['Long']['output'];
};

/** Cash flow NPV totals */
export type CashFlowTotals = {
  defaults_minus_losses_cents: Scalars['Long']['output'];
  interest_cents: Scalars['Long']['output'];
  prepayments_cents: Scalars['Long']['output'];
  principal_cents: Scalars['Long']['output'];
  servicing_cents: Scalars['Long']['output'];
  subtotal_cents: Scalars['Long']['output'];
  total_cents: Scalars['Long']['output'];
};

/**
 * Cashflow projection for an entity. `monthly_cash_flows` / `totals` are the
 * caller's investor share (scaled by each loan's participation). `full_*` fields
 * carry the same projection at 100% tape basis — for REMITTANCES_UPLOAD entities
 * this lets a buyer see the pool-level view and derive the servicer series as
 * (full − investor); for non-remittance entities (OFFERING / POOL / COMPANY)
 * ownership defaults to 1.0 so the two streams are identical.
 */
export type CashFlows = {
  full_monthly_cash_flows?: Maybe<Array<CashFlowMonth>>;
  full_totals?: Maybe<CashFlowTotals>;
  monthly_cash_flows: Array<CashFlowMonth>;
  price_yield_matrix: PriceYieldMatrix;
  totals: CashFlowTotals;
};

export type CheckResult = {
  passFail: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

export type Collateral = {
  building_count?: Maybe<Scalars['Int']['output']>;
  city: Scalars['String']['output'];
  class?: Maybe<Scalars['String']['output']>;
  construction_date_year: Scalars['Int']['output'];
  metropolitan_statistical_area: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupancy_rate_bps?: Maybe<Scalars['Int']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  rentable_square_feet?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  type: Scalars['String']['output'];
  units_count?: Maybe<Scalars['Int']['output']>;
  valuation_as_is_date: Scalars['DateTime']['output'];
  valuation_stabilized_date: Scalars['DateTime']['output'];
  value_as_is_cents: Scalars['Long']['output'];
  value_stabilized_cents: Scalars['Long']['output'];
};

export type CollateralFileDownloadUrlInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  loanID?: InputMaybe<Scalars['ID']['input']>;
};

export type CollateralFileDownloadUrlResponse = {
  URL: Scalars['String']['output'];
};

export type CollateralFileUploadUrlInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  loanID?: InputMaybe<Scalars['ID']['input']>;
};

export type CollateralFileUploadUrlResponse = {
  Metadata?: Maybe<Scalars['JSONObject']['output']>;
  URL: Scalars['String']['output'];
};

export type CollateralNotesInput = {
  dealID: Scalars['ID']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  loanID?: InputMaybe<Scalars['ID']['input']>;
  paginationKey?: InputMaybe<Scalars['String']['input']>;
};

export type CollateralReport = {
  /** ISO formatted date string */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dealId: Scalars['ID']['output'];
  reportTitle?: Maybe<Scalars['String']['output']>;
  /** ISO formatted date string from Unix timestamp */
  uploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  zipFileName: Scalars['String']['output'];
  zipS3VersionID?: Maybe<Scalars['String']['output']>;
};

export type CollateralReportUrl = {
  /** ISO formatted date string */
  expiresAt: Scalars['DateTime']['output'];
  /** ISO formatted date string from Unix timestamp */
  uploadTimestamp?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  zipS3VersionID?: Maybe<Scalars['String']['output']>;
};

export enum CollateralStatus {
  ADDITIONAL_QA_REQUIRED = 'ADDITIONAL_QA_REQUIRED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  REQUIRED = 'REQUIRED'
}

export type CollateralsDocument = {
  ZipFileName?: Maybe<Scalars['String']['output']>;
  collateralID?: Maybe<Scalars['String']['output']>;
  collateralStatus?: Maybe<CollateralStatus>;
  dealID: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  loanID?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  s3Key: Scalars['String']['output'];
};

export type Company = {
  regulatory_metrics?: Maybe<RegulatoryMetrics>;
  type: Scalars['String']['output'];
};

export type CompanyJobsResponse = {
  jobs: Array<Job>;
};

export type ConfirmWireTransferInput = {
  deal_id: Scalars['ID']['input'];
};

export type ContentData = {
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  s3Version: Scalars['String']['output'];
};

export type ContractData = {
  buyerReferenceText: Scalars['String']['output'];
  buyerSigned: Scalars['Boolean']['output'];
  readyToSignBuyer?: Maybe<Scalars['Boolean']['output']>;
  readyToSignSeller?: Maybe<Scalars['Boolean']['output']>;
  sellerReferenceText: Scalars['String']['output'];
  sellerSigned: Scalars['Boolean']['output'];
};

export type ContractItem = {
  buyerCompanyID: Scalars['ID']['output'];
  contractId: Scalars['String']['output'];
  contractSigningError?: Maybe<Scalars['String']['output']>;
  contractUploaded: Scalars['Boolean']['output'];
  contractVersion: Scalars['String']['output'];
  data: ContractData;
  originalFileName: Scalars['String']['output'];
  sellerCompanyID: Scalars['ID']['output'];
};

export type CounterpartyCard = TimelineCard & {
  counterparty: Company;
  deal: Deal;
  /** CounterpertyCard Fields */
  is_under_review: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  role: DealRole;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

export type CounterpartyInsightsCard = TimelineCard & {
  /** CounterpertyInsightsCard Fields */
  counterparty: Company;
  deal: Deal;
  last_updated_date: Scalars['DateTime']['output'];
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

export type CreateDealCarveInput = {
  carve: Array<Filter>;
  deal_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateDealMessageInput = {
  deal_id: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type CreateDiligenceNoteInput = {
  diligence_id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type CreateListingInput = {
  asset_class: AssetClass;
  filters?: InputMaybe<Array<Filter>>;
  origination_type: OriginationType;
  provided_name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new loan pool. */
export type CreatePoolInput = {
  /** Asset class for the pool (AUTO, HOME, etc.) */
  asset_class: AssetClass;
  /** Filters to select loans for the pool. Either filters or loan_ids should be provided. */
  filters?: InputMaybe<Array<Filter>>;
  /** Explicit list of loan IDs to include. Either filters or loan_ids should be provided. */
  loan_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** User-provided name for the pool. If not provided, a name will be generated. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Origination type for the pool. */
  origination_type: OriginationType;
};

/**
 * Result of createPool mutation. Returns either:
 * - UserCompanyListing: Pool was created synchronously (small pools ≤500 loans)
 * - PoolCreationJob: Pool creation job was started (large pools >500 loans)
 */
export type CreatePoolResult = PoolCreationJob | UserCompanyListing;

export type CreateSaleInput = {
  /**
   * When the sale stops taking new access requests; not after first_round_deadline_at. Approvals,
   * Level 2 grants and an approved bidder's access run past it, through the sale's last bid deadline.
   */
  access_cutoff_at: Scalars['DateTime']['input'];
  /** As-of date of the offerings' Book Values. */
  calculation_date: Scalars['Date']['input'];
  /** How long a downloaded protected file stays openable; omitted means 72. */
  download_period_hours?: InputMaybe<Scalars['Int']['input']>;
  first_round_deadline_at: Scalars['DateTime']['input'];
  /** Omitted or empty means every approved bidder. */
  first_round_invited_company_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The seller's pools, one offering each: at most 1000, each once. */
  pools: Array<CreateSalePoolInput>;
  /** A UUID the client mints once per user action and resends on every retry of it. */
  sale_id: Scalars['ID']['input'];
  sale_keys: Array<Scalars['String']['input']>;
  sale_name: Scalars['String']['input'];
  task_order_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSalePoolInput = {
  /**
   * The pool's number in this sale. Trimmed, then refused when blank, over 64 characters or not
   * printable ASCII. No two pools in the sale share one; case counts.
   */
  fdic_pool_number: Scalars['String']['input'];
  pool_id: Scalars['ID']['input'];
};

export type Deal = {
  /** Returns all bids and counterbids for this deal, with information about which side (buyer or seller) submitted each bid */
  bids: Array<DealBid>;
  buyer: Company;
  /** If the buyer has accepted the diligence summary, this will return true. */
  buyer_accepted_diligence: Scalars['Boolean']['output'];
  cards: Array<TimelineCard>;
  /** If the seller uses this api, they must provide a bid_id. If the buyer uses this, it will return all carves. graphql type Bid returns the expected bid_id */
  carves?: Maybe<Array<Maybe<DealCarve>>>;
  carvingEnabled: Scalars['Boolean']['output'];
  counterparty: Company;
  created_date: Scalars['DateTime']['output'];
  /**
   * This returns the loans that are currently selected for diligence.  This is a subset of the loans returned by the loans query,
   * but also includes additional fields that are only relevant to diligence.
   */
  diligence: Array<Diligence>;
  diligence_performance_summary: PerformanceSummary;
  documents: Array<Document>;
  has_new_messages: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_chat_enabled: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing: Listing;
  /** Returns a single loan belonging to the listing. */
  loan?: Maybe<Loan>;
  /** Returns a page of loans for listing purposes. sort and pagination are both required, and filters are optional.  Filters are ANDed together before applying to the loan list. */
  loans: Array<Loan>;
  loans_spreadsheet_url?: Maybe<Scalars['String']['output']>;
  performance_summary: PerformanceSummary;
  /**
   * Forward-looking cashflow projection from the deal's latest approved remittance upload,
   * backed by the Rust cashflow service with entity_type=REMITTANCES_UPLOAD. The resolver
   * derives the upload_id server-side — callers only need the deal identifier. Returns null
   * when the deal has no approved upload yet.
   */
  remittance_performance_summary?: Maybe<PerformanceSummary>;
  role: DealRole;
  seller: Company;
  /** If the seller has accepted the diligence summary, this will return true. */
  seller_accepted_diligence: Scalars['Boolean']['output'];
  state: DealState;
  timeline: Array<TimelineStage>;
};


export type DealCarvesArgs = {
  bid_id?: InputMaybe<Scalars['ID']['input']>;
};


export type DealDiligenceArgs = {
  filters?: InputMaybe<Array<Filter>>;
  pagination: Pagination;
  sort: Sort;
};


export type DealDiligence_Performance_SummaryArgs = {
  filters?: InputMaybe<Array<Filter>>;
};


export type DealDocumentsArgs = {
  fileType?: InputMaybe<FileType>;
  uploader?: InputMaybe<Uploader>;
};


export type DealLoanArgs = {
  id: Scalars['ID']['input'];
};


export type DealLoansArgs = {
  filters?: InputMaybe<Array<Filter>>;
  pagination: Pagination;
  sort: Sort;
};


export type DealLoans_Spreadsheet_UrlArgs = {
  format?: InputMaybe<FileFormat>;
};


export type DealPerformance_SummaryArgs = {
  filters?: InputMaybe<Array<Filter>>;
};


export type DealRemittance_Performance_SummaryArgs = {
  filters?: InputMaybe<Array<Filter>>;
};

export enum DealActionOptionType {
  APPROVE_BUYER = 'APPROVE_BUYER',
  REJECT_BUYER = 'REJECT_BUYER'
}

export type DealBid = {
  bid_basis_points?: Maybe<Scalars['Int']['output']>;
  bid_id: Scalars['ID']['output'];
  bidder: DealRole;
  carve?: Maybe<Array<ExistingFilter>>;
  carve_name: Scalars['String']['output'];
  carve_summary?: Maybe<PerformanceSummary>;
  created_date: Scalars['DateTime']['output'];
  price?: Maybe<Price>;
  prior_bid_id?: Maybe<Scalars['ID']['output']>;
  status: BidStatus;
  stipulations?: Maybe<Stipulations>;
  terms?: Maybe<Array<TermsDocument>>;
};

export enum DealBlocker {
  BOTH = 'BOTH',
  BUYER = 'BUYER',
  NEITHER = 'NEITHER',
  SELLER = 'SELLER'
}

export type DealCarve = {
  carve?: Maybe<Array<ExistingFilter>>;
  carve_summary?: Maybe<PerformanceSummary>;
  deal_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stipulations?: Maybe<Stipulations>;
};

export type DealDocumentsCard = TimelineCard & {
  /** DealDocumentsCard Fields */
  can_upload: Scalars['Boolean']['output'];
  deal: Deal;
  documents: Array<Document>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

export type DealMessage = {
  author: DealMessageAuthor;
  created_time: Scalars['String']['output'];
  deal_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DealMessageAuthor = {
  family_name?: Maybe<Scalars['String']['output']>;
  given_name: Scalars['String']['output'];
  is_current_user: Scalars['Boolean']['output'];
  role: DealMessageAuthorRole;
};

export enum DealMessageAuthorRole {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

export type DealMessageLastEvaluatedKey = {
  created_time: Scalars['String']['output'];
  deal_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type DealMessageLastEvaluatedKeyInput = {
  created_time: Scalars['String']['input'];
  deal_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DealMessageList = {
  entities?: Maybe<Array<Maybe<DealMessage>>>;
  last_evaluated_key?: Maybe<DealMessageLastEvaluatedKey>;
};

export type DealMessagePaginationInput = {
  last_evaluated_key?: InputMaybe<DealMessageLastEvaluatedKeyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort_direction?: InputMaybe<SortDirection>;
};

/** A deal month remittances item, including wire details and optimistic-lock version. */
export type DealMonthRemittancesItem = {
  buyer_remittances_received: Scalars['Boolean']['output'];
  buyer_wire_details?: Maybe<WireDetails>;
  payment_month: Scalars['String']['output'];
  seller_remittances_sent: Scalars['Boolean']['output'];
  seller_wire_details?: Maybe<WireDetails>;
  version: Scalars['Int']['output'];
};

/** One payment month's summary for getDealRemittanceSummaries. */
export type DealRemittanceSummaryByMonth = {
  payment_month: Scalars['String']['output'];
  summary?: Maybe<RemittancesSummary>;
};

export enum DealRole {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

export enum DealSide {
  BOTH = 'BOTH',
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

export type DealState = {
  blocker: DealBlocker;
  label: Scalars['String']['output'];
  loanDataVisible: Scalars['Boolean']['output'];
  status: DealStatus;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export enum DealStatus {
  BID_ACCEPTED = 'BID_ACCEPTED',
  BID_REJECTED = 'BID_REJECTED',
  BUYER_AND_SELLER_NDA = 'BUYER_AND_SELLER_NDA',
  BUYER_NDA = 'BUYER_NDA',
  BUYER_OFFER = 'BUYER_OFFER',
  COMPLETE = 'COMPLETE',
  DILIGENCE = 'DILIGENCE',
  PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
  REJECTED_INQUIRY = 'REJECTED_INQUIRY',
  SELLER_INQUIRY = 'SELLER_INQUIRY',
  SELLER_NDA = 'SELLER_NDA',
  SELLER_REVIEW = 'SELLER_REVIEW',
  WAIT_FOR_CUTOFF = 'WAIT_FOR_CUTOFF',
  WAIT_FOR_WIRE_TRANSFER = 'WAIT_FOR_WIRE_TRANSFER',
  WIRE_TRANSFER_CONFIRMED = 'WIRE_TRANSFER_CONFIRMED',
  WIRE_TRANSFER_SENT = 'WIRE_TRANSFER_SENT'
}

export type DecideSaleBidderInput = {
  action: SaleBidderAction;
  buyer_company_id: Scalars['ID']['input'];
  /** The bidder's version as you read it; a decision on a bidder that has changed since is refused. */
  expected_version: Scalars['Int']['input'];
  /**
   * REMOVE_L2 only, and required there: the FDIC's notice that the bidder's security deposit was
   * returned, such as its date and subject. At most 2,000 characters, and only visible characters and
   * spaces: no line breaks, tabs or invisible formatting characters. Stored on the decision's event,
   * which only your company and ORSNN read.
   */
  note?: InputMaybe<Scalars['String']['input']>;
  sale_id: Scalars['ID']['input'];
};

export enum DefaultAssumptionType {
  CDR = 'CDR',
  SDA = 'SDA'
}

export type DeleteDealCarveInput = {
  buyer_company_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  /** Required for loan service integration to load carve correctly */
  offering_id: Scalars['ID']['input'];
};

export type Diligence = {
  collateral: Array<CollateralsDocument>;
  deal: Deal;
  diligenceAI: DiligenceResponse;
  has_new_notes: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  loan: Loan;
  note_status: NoteStatus;
  status: DiligenceStatus;
};

export enum DiligenceBatchStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export type DiligenceByFile = {
  fileName: Scalars['String']['output'];
  result: CheckResult;
};

export type DiligenceCard = TimelineCard & {
  accepted_bid_summary?: Maybe<PerformanceSummary>;
  /** DiligenceCard Fields */
  asset_class: AssetClass;
  /** The accepted bid */
  bid: Bid;
  buyer_accepted: Scalars['Boolean']['output'];
  deal: Deal;
  /**
   * The diligence reports are only available if the diligence phase is complete. If the diligence phase is not complete, this field will be null.
   * These reports contain the rejected loans and loan left over after diligence was completed in both xlsx and csv formats.
   */
  diligence_reports?: Maybe<DiligenceReports>;
  /** This merely checks if the deal is not in DILIGENCE deal status. */
  is_complete: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  original_pool_summary?: Maybe<PerformanceSummary>;
  post_diligence_summary?: Maybe<PerformanceSummary>;
  role: DealRole;
  seller_accepted: Scalars['Boolean']['output'];
  /** This flag checks if the collateral review is complete and if the diligence reports have been generated. */
  should_show_summaries_tab: Scalars['Boolean']['output'];
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

/** Input types for the new Collateral File and Diligence AI handling. */
export type DiligenceInput = {
  dealId: Scalars['ID']['input'];
};

export type DiligenceNote = {
  author: DealMessageAuthor;
  created_time: Scalars['String']['output'];
  diligence_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type DiligenceNoteLastEvaluatedKey = {
  created_time: Scalars['String']['output'];
  diligence_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type DiligenceNoteLastEvaluatedKeyInput = {
  created_time: Scalars['String']['input'];
  diligence_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DiligenceNoteList = {
  entities?: Maybe<Array<Maybe<DiligenceNote>>>;
  last_evaluated_key?: Maybe<DiligenceNoteLastEvaluatedKey>;
};

export type DiligenceNotePaginationInput = {
  last_evaluated_key?: InputMaybe<DiligenceNoteLastEvaluatedKeyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort_direction?: InputMaybe<SortDirection>;
};

export type DiligenceReports = {
  post_diligence_loans_csv_url: Scalars['String']['output'];
  post_diligence_loans_xlsx_url: Scalars['String']['output'];
  rejected_loans_csv_url: Scalars['String']['output'];
  rejected_loans_xlsx_url: Scalars['String']['output'];
};

/** Response types for the new queries */
export type DiligenceResponse = {
  dealDiligence: Array<LoanDiligence>;
  dealID: Scalars['String']['output'];
  processingStatus?: Maybe<ProcessingStatus>;
};

export enum DiligenceStatus {
  DESELECTED = 'DESELECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING_DOCUMENTS = 'PENDING_DOCUMENTS',
  REJECTED = 'REJECTED',
  REVIEWED = 'REVIEWED'
}

export type DiligenceSummary = {
  consensusDiligence: CheckResult;
  diligenceByFile: Array<DiligenceByFile>;
  finalDiligence: CheckResult;
};

export type Document = {
  documentSizeBytes: Scalars['Int']['output'];
  /**
   * Presigned download link. Null for a document of an FDIC-sale offering, which is released only
   * as a protected download.
   */
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_template: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: FileType;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<DocumentUploader>;
};

export type DocumentUploader = {
  family_name?: Maybe<Scalars['String']['output']>;
  given_name: Scalars['String']['output'];
  is_current_user: Scalars['Boolean']['output'];
};

export type EmergingLendingRisks = {
  benchmarkComparisons?: Maybe<Scalars['String']['output']>;
  increasingDelinquencies?: Maybe<Scalars['String']['output']>;
  lendingPortfolioAnalysis?: Maybe<Scalars['String']['output']>;
  portfolioGrowthRates?: Maybe<Scalars['String']['output']>;
  recessionSensitivityAnalysis?: Maybe<Scalars['String']['output']>;
};

export type Error = {
  detailedMessage?: Maybe<Scalars['String']['output']>;
  missingEnums?: Maybe<Array<Maybe<LoanField>>>;
  multipleHeadersToSingleEnum?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ExecutionType {
  ALL_OR_NOTHING = 'ALL_OR_NOTHING',
  BUYER_CHOICE = 'BUYER_CHOICE'
}

export type ExistingFilter = {
  field_name: FilterableField;
  operand?: Maybe<Scalars['String']['output']>;
  operandList?: Maybe<Array<Scalars['String']['output']>>;
  operator: FilterOperator;
};

/** Feature flag configuration to control feature availability and versions */
export type FeatureFlag = {
  activeVersion: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  versions: Array<FeatureFlagVersion>;
};

/** Specific version of a feature */
export type FeatureFlagVersion = {
  description?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type File = {
  /** When set, this tape is archived (hidden from the default upload-history view). Null when active. See ENG-2845. */
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  asset_class: AssetClass;
  company: Company;
  created_date: Scalars['DateTime']['output'];
  field_mapping: Array<HeaderMap>;
  file_name: Scalars['String']['output'];
  headers?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id: Scalars['ID']['output'];
  persisted_count?: Maybe<Scalars['Int']['output']>;
  persisting_percent?: Maybe<Scalars['Int']['output']>;
  processing_percent?: Maybe<Scalars['Int']['output']>;
  processing_report: ProcessingReport;
  product_type: ProductType;
  state: FileState;
  /** True when uploaded via the Tapestry pipeline (not the legacy SQS path). */
  tapestry_enabled: Scalars['Boolean']['output'];
  /** Current Tapestry pipeline stage; null for legacy uploads. */
  tapestry_stage?: Maybe<Scalars['String']['output']>;
  total_persist_count?: Maybe<Scalars['Int']['output']>;
  uploaded_by: User;
};

export enum FileFormat {
  csv = 'csv',
  xlsx = 'xlsx'
}

export type FileItem = {
  ZipFileName?: Maybe<Scalars['String']['output']>;
  buyerCompanyID?: Maybe<Scalars['String']['output']>;
  collateralID?: Maybe<Scalars['String']['output']>;
  collateralStatus?: Maybe<CollateralStatus>;
  dealID: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  loanID: Scalars['String']['output'];
  offeringID?: Maybe<Scalars['String']['output']>;
  s3Key: Scalars['String']['output'];
  sellerCompanyID?: Maybe<Scalars['String']['output']>;
};

/**
 * Loan tape processing state. For Tapestry uploads at human gates, prefer tapestry_stage and
 * tapestryJobStatus.review.ready_for_review over state alone (see HUMAN_GATES.md).
 */
export enum FileState {
  ERROR = 'ERROR',
  ERROR_HEADER = 'ERROR_HEADER',
  ERROR_PASSWORD = 'ERROR_PASSWORD',
  NEEDS_MAPPING = 'NEEDS_MAPPING',
  NEW = 'NEW',
  PERSISTED = 'PERSISTED',
  PERSISTING = 'PERSISTING',
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING',
  READING_FILE_HEADERS = 'READING_FILE_HEADERS',
  /**
   * Validated and eligible for persist. During Tapestry WAITING_FOR_REVIEW this means
   * awaiting confirmTapestryJob, not auto-saving.
   */
  READY_TO_PERSIST = 'READY_TO_PERSIST',
  READY_TO_PROCESS = 'READY_TO_PROCESS'
}

export enum FileType {
  COLLATERAL_FILE = 'COLLATERAL_FILE',
  DEAL_FILE = 'DEAL_FILE',
  DQ_AND_CHARGE_OFF = 'DQ_AND_CHARGE_OFF',
  LENDING_POLICY = 'LENDING_POLICY',
  LISTING_FILE = 'LISTING_FILE',
  LOAN_TAPE = 'LOAN_TAPE',
  OTHER = 'OTHER',
  SAMPLE_COLLATERAL = 'SAMPLE_COLLATERAL',
  TERMS_DOCUMENT = 'TERMS_DOCUMENT',
  TRANSACTION_DOCUMENT = 'TRANSACTION_DOCUMENT'
}

export type FileWithNotes = {
  file: FileItem;
  notes?: Maybe<Array<Maybe<Note>>>;
};

/** Filter model that requires field_name and operator to be set.  Operand is the default, and only operand OR operandList can be set.  Not both! */
export type Filter = {
  field_name: FilterableField;
  operand?: InputMaybe<Scalars['String']['input']>;
  operandList?: InputMaybe<Array<Scalars['String']['input']>>;
  operator: FilterOperator;
};

export enum FilterOperator {
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  IS = 'IS',
  IS_NOT = 'IS_NOT',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS'
}

export type FilterTemplate = {
  filters: Array<ExistingFilter>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum FilterableField {
  account_id = 'account_id',
  age_months = 'age_months',
  amortization_term_months = 'amortization_term_months',
  arm_index = 'arm_index',
  arm_index_rate_bps = 'arm_index_rate_bps',
  arm_margin_bps = 'arm_margin_bps',
  asset_class = 'asset_class',
  auto_original_value_cents = 'auto_original_value_cents',
  balloon_term_months = 'balloon_term_months',
  borrower_credit_score = 'borrower_credit_score',
  /**
   * MARINE fields (ENG-2961). Capture-only but filterable; canonical LoanItem
   * fields (added in loan-service for ENG-2969), so they pass loan-management's
   * reflection-based field-name validator.
   */
  charter = 'charter',
  city = 'city',
  combined_ltv_bps = 'combined_ltv_bps',
  cra = 'cra',
  /**
   * HELOC fields
   * NOTE: available_credit_cents is intentionally omitted — it's derived
   * (credit_line_amount_cents - current_balance_cents), not stored on the
   * underlying LoanItem in loan-management. Listing it here would let
   * filter/projection queries reference it and error at runtime in the
   * loan-management reflection-based field-name validator.
   */
  credit_line_amount_cents = 'credit_line_amount_cents',
  current_balance_cents = 'current_balance_cents',
  /** remittance record fields (e.g. getUploadRemittanceRecords) */
  days_past_due = 'days_past_due',
  dealer_reserve_bps = 'dealer_reserve_bps',
  dealer_reserve_cents = 'dealer_reserve_cents',
  draw_period_months = 'draw_period_months',
  draw_start_date_seconds = 'draw_start_date_seconds',
  /**
   * DSCR / Non-QM subtype (ENG-2853). dscr_bps is a residential DSCR ratio in
   * bps (1.25x = 12500); cashflows already filters on it (ENG-2832). Canonical
   * LoanItem field, so it passes loan-management's field-name validator.
   */
  dscr_bps = 'dscr_bps',
  dti_bps = 'dti_bps',
  first_payment_date_seconds = 'first_payment_date_seconds',
  /** ARM fields */
  first_rate_change_date_seconds = 'first_rate_change_date_seconds',
  fund_number = 'fund_number',
  institution_id = 'institution_id',
  interest_only = 'interest_only',
  interest_rate_bps = 'interest_rate_bps',
  io_period_months = 'io_period_months',
  irap_months = 'irap_months',
  last_loan_tape_id = 'last_loan_tape_id',
  last_loan_tape_name = 'last_loan_tape_name',
  last_updated_date_seconds = 'last_updated_date_seconds',
  lien_position = 'lien_position',
  lifetime_cap_rate_bps = 'lifetime_cap_rate_bps',
  lifetime_floor_rate_bps = 'lifetime_floor_rate_bps',
  listing_id = 'listing_id',
  loan_number = 'loan_number',
  loan_terms_months = 'loan_terms_months',
  ltv_bps = 'ltv_bps',
  maturity_date_seconds = 'maturity_date_seconds',
  next_payment_date_seconds = 'next_payment_date_seconds',
  /** HOME fields */
  occupancy = 'occupancy',
  original_balance_cents = 'original_balance_cents',
  origination_date_seconds = 'origination_date_seconds',
  payment_month = 'payment_month',
  performance_status = 'performance_status',
  periodic_cap_rate_bps = 'periodic_cap_rate_bps',
  postal_code = 'postal_code',
  product = 'product',
  purpose = 'purpose',
  rap_months = 'rap_months',
  remaining_loan_terms_months = 'remaining_loan_terms_months',
  repayment_period_months = 'repayment_period_months',
  /** FDIC loan fields, filtered by cashflows. asset_name is left out: it is PII. */
  sale_key = 'sale_key',
  state = 'state',
  /** This field can only be used with Diligence filters */
  status = 'status'
}

export type FundingSchedule = {
  bid_basis_points: Scalars['Float']['output'];
  purchase_date?: Maybe<Scalars['DateTime']['output']>;
};

export type FundingScheduleDetailsCard = TimelineCard & {
  /** FundingScheduleDetailsCard Fields */
  bid: Bid;
  can_edit_wire_details: Scalars['Boolean']['output'];
  deal: Deal;
  funding_schedule: FundingSchedule;
  last_updated_date: Scalars['DateTime']['output'];
  should_show_wire_details: Scalars['Boolean']['output'];
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
  wire_details?: Maybe<WireDetails>;
};

export type FundingScheduleInputCard = TimelineCard & {
  /** FundingScheduleInputCard Fields */
  can_edit_funding_schedule: Scalars['Boolean']['output'];
  deal: Deal;
  funding_schedule?: Maybe<FundingSchedule>;
  last_updated_date: Scalars['DateTime']['output'];
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

/** Input for getAccountRemittanceRecords: deal and account_ids. Returns all months of records for each account, grouped by account_id. */
export type GetAccountRemittanceRecordsInput = {
  /** Account IDs (from tape) to fetch remittance records for across all approved months */
  account_ids: Array<Scalars['ID']['input']>;
  /** ID of the deal */
  deal_id: Scalars['ID']['input'];
};

/** Response for getAccountRemittanceRecords: records grouped by account_id. */
export type GetAccountRemittanceRecordsResponse = {
  records_by_account_id: Array<AccountRemittanceRecords>;
};

/** Input for getAccountRemittanceVariances: fetch variances for specific accounts within an upload. */
export type GetAccountRemittanceVariancesInput = {
  account_ids: Array<Scalars['String']['input']>;
  upload_id: Scalars['ID']['input'];
};

/** Response for getAccountRemittanceVariances: variances grouped by account_id. */
export type GetAccountRemittanceVariancesResponse = {
  variances_by_account: Array<AccountRemittanceVariances>;
};

export type GetCollateralReportUrlInput = {
  dealId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
  zipFileName: Scalars['String']['input'];
};

export type GetContractFileGetUrlInput = {
  contractId: Scalars['ID']['input'];
  contractVersion: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
};

export type GetContractFilePostUrlInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  dealId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

/** Input for getDealMonthRemittances. */
export type GetDealMonthRemittancesInput = {
  /** ID of the deal */
  deal_id: Scalars['ID']['input'];
  /** Payment month in YYYY-MM format */
  payment_month: Scalars['String']['input'];
};

/** Response for getDealMonthRemittances. */
export type GetDealMonthRemittancesResponse = {
  item?: Maybe<DealMonthRemittancesItem>;
};

/** Input for getDealRemittanceSummaries: deal. Returns aggregated summaries per approved payment month. */
export type GetDealRemittanceSummariesInput = {
  /** ID of the deal */
  deal_id: Scalars['ID']['input'];
};

/** Response for getDealRemittanceSummaries: summaries keyed by payment month. */
export type GetDealRemittanceSummariesResponse = {
  summaries_by_payment_month: Array<DealRemittanceSummaryByMonth>;
};

export type GetFileUuidInput = {
  /** Required for LOAN_TAPE, otherwise will return an error */
  assetClass?: InputMaybe<AssetClass>;
  fileName: Scalars['String']['input'];
  fileType: FileType;
  parentId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<ProductType>;
  s3VersionId: Scalars['String']['input'];
};

export type GetPreferencesResponse = {
  userPreferences: UserPreferences;
};

/** Get remittance notes for a given account (remittance account id). */
export type GetRemittanceNotesInput = {
  accountID: Scalars['ID']['input'];
  buyerCompanyID: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offeringID: Scalars['ID']['input'];
  paginationKey?: InputMaybe<Scalars['String']['input']>;
};

export type GetRemittanceNotesResponse = {
  nextPaginationKey?: Maybe<Scalars['String']['output']>;
  notes: Array<Note>;
};

export type GetRemittanceTapePostUrlInput = {
  /** Content type for the upload (e.g. text/csv, application/vnd.ms-excel) */
  content_type: Scalars['String']['input'];
  /** Deal ID (composite: OFFERING#<offering_id>#BUYER#<buyer_company_id>) */
  deal_id: Scalars['ID']['input'];
  /** Original file name (used in S3 key and object metadata for the lambda) */
  file_name: Scalars['String']['input'];
  /** Payment month in YYYY-MM format (e.g. 2024-01) */
  payment_month: Scalars['String']['input'];
};

export type GetSelectDiligenceStatusInput = {
  deal_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Input for getSingleMonthRemittanceRecords: deal, optional month, and either account_ids (batch) or filters (query), plus optional pagination. */
export type GetSingleMonthRemittanceRecordsInput = {
  /** Optional: fetch these account IDs (batch). Mutually exclusive with filters. */
  account_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Deal ID (composite: OFFERING#<offering_id>#BUYER#<buyer_company_id>) */
  deal_id: Scalars['ID']['input'];
  /** Optional: server-side filters (query path). Mutually exclusive with account_ids. */
  filters?: InputMaybe<Array<Filter>>;
  /** Optional pagination (page_size, offset). Applied in API layer. */
  pagination?: InputMaybe<Pagination>;
  /** Payment month (YYYY-MM). If omitted, latest approved month for the deal is used. */
  payment_month?: InputMaybe<Scalars['String']['input']>;
};

/** Response for getSingleMonthRemittanceRecords: list of remittance records for the deal/month (each record includes marks_by_month when available). */
export type GetSingleMonthRemittanceRecordsResponse = {
  entities: Array<RemittanceRecord>;
};

/** Input for querying remittance records by upload_id. Pagination is applied in the API layer (page_size, offset). */
export type GetUploadRemittanceRecordsInput = {
  /** Optional filters to apply to the remittance records */
  filters?: InputMaybe<Array<Filter>>;
  /** Optional pagination (same shape as other data table queries). Uses page_size and offset; cursor fields reserved for future use. */
  pagination?: InputMaybe<Pagination>;
  /** Optional sort (server-side via analytics datatable). When provided, the analytics service handles sorting and pagination. */
  sort?: InputMaybe<Sort>;
  /** ID of the remittance upload to get records for */
  upload_id: Scalars['ID']['input'];
};

/** Response for getUploadRemittanceRecords: records for the requested page, upload status, and optional summary. */
export type GetUploadRemittanceRecordsResponse = {
  /** List of remittance records for the upload (paginated in API layer by page_size and offset). */
  entities: Array<RemittanceRecord>;
  /** Aggregated totals for the upload, if available */
  summary?: Maybe<RemittancesSummary>;
  /**
   * Total number of records matching current filters (for pagination controls).
   * When sort is provided, this comes from the analytics service; otherwise from in-memory count.
   */
  total_count?: Maybe<Scalars['Int']['output']>;
  /** Upload lifecycle status (PENDING, APPROVED, REJECTED). Empty if upload not found. */
  upload_status: RemittancesUploadStatus;
};

/** Input for getUploadRemittanceVariances: paginated query of all variances for an upload. */
export type GetUploadRemittanceVariancesInput = {
  last_evaluated_sk?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  upload_id: Scalars['ID']['input'];
};

/** Response for getUploadRemittanceVariances. */
export type GetUploadRemittanceVariancesResponse = {
  items: Array<RemittanceRecordVariance>;
  last_evaluated_sk?: Maybe<Scalars['String']['output']>;
};

export type GetUserNotificationsResponse = {
  notifications?: Maybe<Array<NotificationResponse>>;
};

export type GetValidTermsInput = {
  fieldNames: Array<FilterableField>;
  filters?: InputMaybe<Array<Filter>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentType: ParentType;
};

export type Guarantor = {
  credit_score: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HelocLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  /** Secured Consumer loan fields */
  city?: Maybe<Scalars['String']['output']>;
  combined_ltv_bps?: Maybe<Scalars['Int']['output']>;
  company: PrivateCompany;
  /** HELOC-specific fields */
  credit_line_amount_cents?: Maybe<Scalars['Long']['output']>;
  currency_code: Scalars['String']['output'];
  /**
   * current_balance_cents doubles as utilized balance for HELOC.
   * Available credit = credit_line_amount_cents - current_balance_cents.
   */
  current_balance_cents: Scalars['Long']['output'];
  draw_period_months?: Maybe<Scalars['Int']['output']>;
  draw_start_date?: Maybe<Scalars['DateTime']['output']>;
  /** ConsumerLoan fields; dti_bps is null for asset-depletion loans (ENG-3391) */
  dti_bps?: Maybe<Scalars['Int']['output']>;
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  /** Loan fields */
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  lien_position?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months?: Maybe<Scalars['Int']['output']>;
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date?: Maybe<Scalars['DateTime']['output']>;
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date?: Maybe<Scalars['DateTime']['output']>;
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  postal_code?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  property_year?: Maybe<Scalars['Int']['output']>;
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  repayment_period_months?: Maybe<Scalars['Int']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** ASSET_UTIL when the tape's asset_based_decision flag was truthy (ENG-3391) */
  underwriting_type?: Maybe<UnderwritingType>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type HeaderMap = {
  field: LoanField;
  file_column: Scalars['String']['output'];
};

export type HeaderMapInput = {
  field: LoanField;
  file_column: Scalars['String']['input'];
};

export type HomeLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  amortization_term_months?: Maybe<Scalars['Int']['output']>;
  arm_index?: Maybe<Scalars['String']['output']>;
  arm_index_rate_bps?: Maybe<Scalars['Int']['output']>;
  arm_margin_bps?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  balloon_term_months?: Maybe<Scalars['Int']['output']>;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  /** Secured Consumer loan fields (integer bps) */
  city?: Maybe<Scalars['String']['output']>;
  company: PrivateCompany;
  /** HomeLoan specific */
  cra: Scalars['Boolean']['output'];
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  dscr_bps?: Maybe<Scalars['Int']['output']>;
  /** ConsumerLoan specific (integer bps) */
  dti_bps?: Maybe<Scalars['Int']['output']>;
  first_payment_date: Scalars['DateTime']['output'];
  /** ARM fields */
  first_rate_change_date?: Maybe<Scalars['DateTime']['output']>;
  fund_number?: Maybe<Scalars['String']['output']>;
  /** ConsumerLoan implemented fields */
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_only?: Maybe<Scalars['Boolean']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  io_period_months?: Maybe<Scalars['Int']['output']>;
  irap_months?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  lifetime_cap_rate_bps?: Maybe<Scalars['Int']['output']>;
  lifetime_floor_rate_bps?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months: Scalars['Int']['output'];
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date: Scalars['DateTime']['output'];
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  occupancy?: Maybe<Scalars['String']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date: Scalars['DateTime']['output'];
  performance_status?: Maybe<PerformanceStatus>;
  periodic_cap_rate_bps?: Maybe<Scalars['Int']['output']>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  postal_code?: Maybe<Scalars['String']['output']>;
  prepayment_penalty?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  /** Program description (PRD "program_description"); program == the product field above. */
  product_description?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  property_year?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  /**
   * DSCR / Non-QM subtype (ENG-2825). qm_status null ⇒ treated as QM.
   * dscr_bps is DSCR × 10000 (1.25x = 12500).
   */
  qm_status?: Maybe<QmStatus>;
  rap_months?: Maybe<Scalars['Int']['output']>;
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  rent_type?: Maybe<Scalars['String']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  underwriting_type?: Maybe<UnderwritingType>;
  version?: Maybe<Scalars['Long']['output']>;
};

/**
 * Background job interface - common fields for all job types.
 * Use inline fragments to access job-type-specific fields.
 */
export type Job = {
  created_at: Scalars['Long']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  estimated_count: Scalars['Int']['output'];
  job_id: Scalars['ID']['output'];
  job_type: JobType;
  processed_count: Scalars['Int']['output'];
  progress_percentage: Scalars['Int']['output'];
  /**
   * When the job began processing (milliseconds timestamp).
   * Used for calculating ETA and remaining time estimates.
   * Null if job hasn't started yet (PENDING status).
   */
  started_at?: Maybe<Scalars['Long']['output']>;
  status: JobStatusEnum;
  updated_at: Scalars['Long']['output'];
};

/** Status of a background job - maps to loan-management JobStatus */
export enum JobStatusEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

/** Type of background job - maps to loan-management JobType */
export enum JobType {
  OFFERING_CREATION = 'OFFERING_CREATION',
  POOL_CREATION = 'POOL_CREATION',
  SALE_CREATION = 'SALE_CREATION'
}

/** New types for Collateral Processing Reports */
export type ListCollateralReportsInput = {
  dealId: Scalars['ID']['input'];
};

export type ListCollateralReportsResponse = {
  reports: Array<CollateralReport>;
};

export type Listing = {
  asset_class: AssetClass;
  company: Company;
  created_date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** When the offering leaves the marketplace. Null for a pool-backed listing, which does not expire. */
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  has_cra?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** This field is the deal id in progress for the listing for the user's company */
  in_progress_deal_id?: Maybe<Scalars['String']['output']>;
  last_updated_date: Scalars['DateTime']['output'];
  loan_count?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  origination_type: OriginationType;
  /** This field should be ignored if execution type is "all or nothing". */
  performance_summary: PerformanceSummary;
  provided_name?: Maybe<Scalars['String']['output']>;
  /**
   * The FDIC sale this offering is a pool of; null on a marketplace offering. Raw loan-data
   * exports are withheld for an offering in a sale.
   */
  sale_id?: Maybe<Scalars['ID']['output']>;
  state: ListingState;
  t_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  top_states?: Maybe<Array<Scalars['String']['output']>>;
  wa_borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  wa_coupon_bps?: Maybe<Scalars['Int']['output']>;
  wa_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_dti_bps?: Maybe<Scalars['Int']['output']>;
  wa_loan_age_months?: Maybe<Scalars['Int']['output']>;
  wa_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_original_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_remaining_loan_terms_months?: Maybe<Scalars['Float']['output']>;
};

export enum ListingState {
  ACTIVE = 'ACTIVE',
  DELETING = 'DELETING',
  NEEDS_REFRESH = 'NEEDS_REFRESH',
  NEW = 'NEW',
  READY_TO_CREATE = 'READY_TO_CREATE',
  REFRESHED = 'REFRESHED',
  SCANNING = 'SCANNING',
  TO_DELETE = 'TO_DELETE'
}

/** see Entity.ts for corresponding types */
export type Loan = {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  company: PrivateCompany;
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  /** The name of the loan tape file that was last used to update this loan. */
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months?: Maybe<Scalars['Int']['output']>;
  maturity_date?: Maybe<Scalars['DateTime']['output']>;
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date?: Maybe<Scalars['DateTime']['output']>;
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  product?: Maybe<Scalars['String']['output']>;
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  /** FDIC sale fields */
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type LoanData = {
  dataDrivenInsights: Array<Scalars['String']['output']>;
  emergingLendingRisks?: Maybe<EmergingLendingRisks>;
};

export type LoanDiligence = {
  diligenceSummary: DiligenceSummary;
  loanId: Scalars['String']['output'];
};

export enum LoanField {
  account_id = 'account_id',
  age_months = 'age_months',
  amortization_term_months = 'amortization_term_months',
  arm_index = 'arm_index',
  arm_index_rate_bps = 'arm_index_rate_bps',
  arm_margin_bps = 'arm_margin_bps',
  /**
   * Asset-depletion flag (ENG-3391): optional consumer-wide truthy column
   * ("1"/"true"/"yes"). Classifier input for underwriting_type ASSET_UTIL and
   * the row-level escape that lets dti_bps be genuinely blank. Transient tape
   * field — not persisted to loan-service, so not a LoanItem field.
   */
  asset_based_decision = 'asset_based_decision',
  asset_class = 'asset_class',
  auto_original_value_cents = 'auto_original_value_cents',
  auto_vin = 'auto_vin',
  balloon_term_months = 'balloon_term_months',
  boat_make = 'boat_make',
  boat_model = 'boat_model',
  borrower_credit_score = 'borrower_credit_score',
  /**
   * MARINE fields (ENG-2961). Canonical LoanItem fields (added in loan-service
   * for ENG-2969), so they pass loan-management's field-name validator.
   */
  charter = 'charter',
  city = 'city',
  combined_ltv_bps = 'combined_ltv_bps',
  cra = 'cra',
  /**
   * HELOC fields
   * NOTE: available_credit_cents is intentionally omitted — it's derived
   * (credit_line_amount_cents - current_balance_cents), not stored on the
   * underlying LoanItem in loan-management. Listing it here would let
   * filter/projection queries reference it and error at runtime in the
   * loan-management reflection-based field-name validator.
   */
  credit_line_amount_cents = 'credit_line_amount_cents',
  current_balance_cents = 'current_balance_cents',
  dealer_reserve_bps = 'dealer_reserve_bps',
  dealer_reserve_cents = 'dealer_reserve_cents',
  draw_period_months = 'draw_period_months',
  draw_start_date_seconds = 'draw_start_date_seconds',
  dscr_bps = 'dscr_bps',
  dti_bps = 'dti_bps',
  first_payment_date_seconds = 'first_payment_date_seconds',
  /** ARM fields */
  first_rate_change_date_seconds = 'first_rate_change_date_seconds',
  fund_number = 'fund_number',
  institution_id = 'institution_id',
  interest_only = 'interest_only',
  interest_rate_bps = 'interest_rate_bps',
  io_period_months = 'io_period_months',
  irap_months = 'irap_months',
  last_loan_tape_id = 'last_loan_tape_id',
  last_loan_tape_name = 'last_loan_tape_name',
  last_updated_date_seconds = 'last_updated_date_seconds',
  lien_position = 'lien_position',
  lifetime_cap_rate_bps = 'lifetime_cap_rate_bps',
  lifetime_floor_rate_bps = 'lifetime_floor_rate_bps',
  loan_number = 'loan_number',
  loan_terms_months = 'loan_terms_months',
  ltv_bps = 'ltv_bps',
  maturity_date_seconds = 'maturity_date_seconds',
  next_payment_date_seconds = 'next_payment_date_seconds',
  occupancy = 'occupancy',
  /**
   * CRE occupancy rate (ratio/percent → bps). Mappable via occupancy_rate alias;
   * defined in CRE validation config. Same class of addition as dscr_bps (ENG-2837).
   */
  occupancy_rate_bps = 'occupancy_rate_bps',
  original_balance_cents = 'original_balance_cents',
  origination_date_seconds = 'origination_date_seconds',
  performance_status = 'performance_status',
  periodic_cap_rate_bps = 'periodic_cap_rate_bps',
  postal_code = 'postal_code',
  product = 'product',
  property_description = 'property_description',
  property_year = 'property_year',
  purpose = 'purpose',
  /**
   * DSCR / Non-QM subtype (ENG-2828). Mappable so the client field-mapping UI
   * (ENG-2841) can target them — qm_status is the Mixed-mode Non-QM flag column;
   * dscr_bps / rent_type are auto-mapped but also manually mappable. These are
   * canonical LoanItem fields, so they pass loan-management's field-name
   * validator. underwriting_type is intentionally omitted — it's classifier-
   * derived, never seller-mapped; sellers map the *inputs* below instead.
   */
  qm_status = 'qm_status',
  rap_months = 'rap_months',
  remaining_loan_terms_months = 'remaining_loan_terms_months',
  rent_type = 'rent_type',
  repayment_period_months = 'repayment_period_months',
  /** FDIC sale fields. Canonical LoanItem fields (loan-service types.Loan). */
  sale_key = 'sale_key',
  servicing_rate_bps = 'servicing_rate_bps',
  state = 'state'
}

export type LoansCard = TimelineCard & {
  /** LoansCard Fields */
  allow_filtering: Scalars['Boolean']['output'];
  asset_class: AssetClass;
  deal: Deal;
  last_updated_date: Scalars['DateTime']['output'];
  loans_spreadsheet_url_csv?: Maybe<Scalars['String']['output']>;
  /**
   * Null when the deal's status puts loan data out of reach, or when no tape has
   * been generated for the offering yet.
   */
  loans_spreadsheet_url_xlsx?: Maybe<Scalars['String']['output']>;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

/** Login Method Enum */
export enum LoginMethod {
  NATIVE = 'NATIVE',
  SSO = 'SSO'
}

export type MarineLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  boat_make?: Maybe<Scalars['String']['output']>;
  boat_model?: Maybe<Scalars['String']['output']>;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  /** MarineLoan specific (ENG-2961), capture-only */
  charter?: Maybe<Scalars['Boolean']['output']>;
  /** Secured Consumer loan fields (integer bps, e.g. 8000 = 80%) */
  city?: Maybe<Scalars['String']['output']>;
  company: PrivateCompany;
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  dealer_reserve_bps?: Maybe<Scalars['Int']['output']>;
  dealer_reserve_cents?: Maybe<Scalars['Long']['output']>;
  /** ConsumerLoan specific (integer bps); null for asset-depletion loans (ENG-3391) */
  dti_bps?: Maybe<Scalars['Int']['output']>;
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  /** ConsumerLoan implemented fields */
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months: Scalars['Int']['output'];
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date: Scalars['DateTime']['output'];
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date: Scalars['DateTime']['output'];
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  postal_code?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  property_year?: Maybe<Scalars['Int']['output']>;
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  /** ASSET_UTIL when the tape's asset_based_decision flag was truthy (ENG-3391) */
  underwriting_type?: Maybe<UnderwritingType>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type MarkCollateralReviewCompleteInput = {
  deal_id: Scalars['ID']['input'];
};

export type MarkDiligenceAcceptedInput = {
  accepted: Scalars['Boolean']['input'];
  deal_id: Scalars['ID']['input'];
};

export type MarkDiligenceCompleteInput = {
  deal_id: Scalars['ID']['input'];
};

export type MarkReadRequest = {
  notificationID: Scalars['String']['input'];
};

export type MarkReadResponse = {
  success: Scalars['Boolean']['output'];
};

export type MarkSettlementCompleteInput = {
  deal_id: Scalars['ID']['input'];
};

export type MarketData = {
  urlMap: Scalars['JSON']['output'];
};

export type Match = {
  csvHeader?: Maybe<Scalars['String']['output']>;
  loanField?: Maybe<LoanField>;
};

export type MemberBusinessLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  /** BusinessLoan Fields */
  amortization_term_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  borrower: Borrower;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** MemberBusinessLoan specific fields */
  collateral: Collateral;
  company: PrivateCompany;
  cra?: Maybe<Scalars['Boolean']['output']>;
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  future_advance_cents: Scalars['Long']['output'];
  /** Loan fields */
  id: Scalars['ID']['output'];
  initial_advance_cents: Scalars['Long']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months?: Maybe<Scalars['Int']['output']>;
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date?: Maybe<Scalars['DateTime']['output']>;
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date?: Maybe<Scalars['DateTime']['output']>;
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  product?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  property_year: Scalars['Int']['output'];
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  total_commitment_cents: Scalars['Long']['output'];
  version?: Maybe<Scalars['Long']['output']>;
};

export type MultipleCollateralFilesMetadataInput = {
  dealID: Scalars['ID']['input'];
};

export type MultipleCollateralFilesMetadataResponse = {
  files: Array<FileItem>;
};

export type Mutation = {
  acceptBid: Deal;
  /**
   * Records that you acknowledged this version of a sale document for your company, with the IP
   * address and user agent api observed and your name, email, title and company name as they are now.
   * document_sha256 is the lowercase hex SHA-256 of the exact text you were shown. A repeat with the
   * same text succeeds and keeps the first acknowledgement; different text for the same version is
   * refused. Returns your access afterwards.
   */
  acknowledgeSaleDocument?: Maybe<SaleAccess>;
  addCollateralNote: Note;
  /** deal timeline apis */
  addDealMessage: DealMessage;
  addDiligenceNote: DiligenceNote;
  /** Adds a note to a remittance for a specific deal and loan */
  addRemittanceNote: Note;
  /** ## User Mutations */
  addUserSetting: Scalars['Boolean']['output'];
  /** Adds a note to the wire details file */
  addWireDetailsNote: WireDetailsNote;
  advanceDeal: Deal;
  /** Approves a remittance tape upload (sets upload status to APPROVED). Only the deal seller may approve. Upload must be PENDING. */
  approveRemittanceRecords: Scalars['Boolean']['output'];
  /**
   * Opens the caller's company's PENDING_APPROVAL sale to bidders, recording the caller as its
   * approver. A repeat by the same user returns the sale. Seller only, for now.
   */
  approveSale?: Maybe<Sale>;
  /**
   * Soft-archive loan tapes (hide from the default upload-history view). Does not delete the tape or
   * the loans it imported. Blocks tapes that are still processing. See ENG-2845.
   */
  archiveLoanTapes: ArchiveLoanTapesResponse;
  /** Archives multiple pools for a company. */
  archivePools: ArchivePoolsResponse;
  /** Tapestry: cancel a file processing job (stub). */
  cancelTapestryJob: TapestryJobStatus;
  /** Tapestry: confirm a file processing job (stub). */
  confirmTapestryJob: TapestryJobStatus;
  confirmWireTransfer: Deal;
  createDealCarve: DealCarve;
  /**
   * Throws error if the seller tries to create a deal with themselves.
   * @deprecated Use createPool instead, which handles both sync and async pool creation
   */
  createListing: Listing;
  /**
   * Create a new loan pool. Automatically determines sync vs async creation:
   * - Small pools (≤500 loans): Created synchronously, returns UserCompanyListing
   * - Large pools (>500 loans): Creates async job, returns PoolCreationJob
   *
   * Use inline fragments to handle both result types:
   * ```graphql
   * mutation {
   *   createPool(input: {...}) {
   *     ... on UserCompanyListing { id name }
   *     ... on PoolCreationJob { job_id status progress_percentage }
   *   }
   * }
   * ```
   */
  createPool: CreatePoolResult;
  /**
   * Issues a watermarked, encrypted copy of an FDIC sale document to the caller. Access (approved
   * bidder, CA accepted, level, before the sale's last bid deadline) is checked against the sale
   * model; the document's level comes from the sale model, never from the client. Every bidder
   * request for a Level 2 document, DOWNLOAD or VIEW, must carry piiNoticeAcknowledged: true and
   * piiNoticeVersion, sent when the user accepts the Special PII Notice for that open.
   * piiNoticeVersion is the version of the notice the user was shown, as specialPiiNotice serves it:
   * api checks only that, once trimmed, it is non-blank, at most 64 UTF-16 code units and free of
   * control, format and unpaired surrogate characters, and records it trimmed. Nothing is
   * remembered between requests: a bidder who may otherwise have the document is refused it with
   * code PII_NOTICE_REQUIRED on each request without both. Both are ignored for a Level 1 document
   * and for a reviewer's copy. Never retried: each call issues a new download and
   * new access-log rows. asReviewer asks for a reviewer's copy instead: it needs the caller's own
   * reviewer grant on the sale (never a bidder registration), covers every level before the sale's
   * access cut-off, needs no PII notice, and is stamped REVIEW COPY.
   */
  createProtectedDownload: ProtectedDownload;
  /**
   * Starts creating a sale for the caller's company. The returned job builds one offering per pool
   * and leaves the sale PENDING_APPROVAL for approveSale; poll saleCreationJob. A repeat with the same
   * sale_id returns the stored sale's job. It must send the same pools and sale keys, and, while
   * loan-service still holds the job, the same FDIC pool numbers.
   * A pool the caller's company does not have fails with its ID in `extensions.pool_id`.
   */
  createSale?: Maybe<SaleCreationJob>;
  /**
   * Approves, rejects, revokes, grants L2 to, or removes L2 or a standing vetting sign-off from, a
   * bidder on your company's sale, if the bidder is still at expected_version. Seller only, and only a user with the deal_manager role.
   * GRANT_L2 is refused until the bidder's vetting_completed_at is set.
   */
  decideSaleBidder?: Maybe<SaleBidder>;
  deleteContract: Scalars['Boolean']['output'];
  deleteDealCarve: Scalars['Boolean']['output'];
  deleteS3File: Scalars['Boolean']['output'];
  disableChat: UserCompany;
  /** company APIs */
  enableChat: UserCompany;
  /** Gets an upload URL for a collateral file */
  getCollateralFileUploadURL: CollateralFileUploadUrlResponse;
  getCollateralReportUrl: CollateralReportUrl;
  getContractFileGetUrl: Scalars['String']['output'];
  getContractFilePostUrl: Scalars['String']['output'];
  /**
   * Returns an upload link for the file submitted. Parent Id depends on the filetype.
   * LISTING_FILE gets a listing id, DEAL_FILE gets a deal id, LOAN_TAPE doesn't require an ID, but uses company id on the backend, since users can only upload loan tapes to their own company.
   */
  getFilePostUrl: Scalars['String']['output'];
  /**
   * Returns a presigned POST URL and form fields for uploading a remittance tape file.
   * Metadata (deal_id, payment_month) is bound server-side so the object key/metadata
   * in S3 carries context for the single lambda that reads the file and calls loan-service.
   * Client POSTs the file (e.g. multipart form) to postUrl with the returned formFields.
   */
  getRemittanceTapePostUrl: RemittanceTapePostUrlResponse;
  /** Gets the presigned upload url for a wire deatils file */
  getWireDetailsFileUploadURL: WireDetailsFileUploadUrlResponse;
  ingestFile: File;
  /**
   * Records in the audit log copy, cut and context-menu attempts the client blocked on a protected
   * loan table: count is the number of attempts of one kind since the last call, from 1 to 10000.
   */
  logSalePoolLoanTableEvent: Scalars['Boolean']['output'];
  markCollateralReviewComplete: Deal;
  markDiligenceAccepted: Deal;
  markDiligenceComplete: Deal;
  markDocumentReadyToSign: Scalars['Boolean']['output'];
  markNotificationRead: MarkReadResponse;
  markSettlementComplete: Deal;
  /**
   * Opens a pool's loan table. For a bidder it registers the view with IRM protect, which checks
   * revocations and returns no file; the client then opens view_id with the key service's /view
   * before calling salePoolLoans. At L2 it needs pii_notice_acknowledged: true and
   * pii_notice_version, checked as createProtectedDownload checks them, and is refused with code
   * PII_NOTICE_REQUIRED without them. Errors carry createProtectedDownload's extensions: code,
   * reason, retryable and errorClass, and a revocation is ACCESS_REVOKED with protect's reason. The
   * seller gets its watermark fields and no IRM session: view_id and expires_at are null, and it may
   * preview a bidder's level with view_as, which anyone else is refused. Never retried: each call
   * registers a new view.
   */
  openSalePoolLoanTable: SalePoolLoanTableSession;
  /** notification APIs */
  putNotificationPreferences: PutPreferencesResponse;
  /** Rejects a remittance tape upload (sets upload status to REJECTED). Only the deal seller may reject. Upload must be PENDING. */
  rejectRemittanceRecords: Scalars['Boolean']['output'];
  /** Tapestry: reject a file processing job (stub). */
  rejectTapestryJob: TapestryJobStatus;
  removeCollateralFile: RemoveCollateralFileResponse;
  /** Remove an uploaded wire deatils file */
  removeWireDetailsFile: RemoveWireDetailsFileResponse;
  /**
   * Requests access to an FDIC sale for your company. A repeat while the request is PENDING returns
   * it unchanged.
   */
  requestSaleAccess?: Maybe<SaleBidder>;
  /** Tapestry: retry a file processing job (stub). */
  retryTapestryJob: TapestryJobStatus;
  /**
   * Runs the bid optimizer on a round's cash bids and stores the run as the round's next version. For
   * the sale's seller, once the round has unsealed; a Sealed error before.
   */
  runBidOptimization?: Maybe<SaleBidOptimizationRun>;
  saveContractReferenceText: ContractItem;
  saveContractSignature: Scalars['Boolean']['output'];
  /**
   * Saves your company's private draft of a series' bid, over any earlier draft. A draft is not a bid:
   * the seller never sees it, and it counts only once submitted with submitSaleBid. Taken only where
   * submitSaleBid would take the bid now, so it is refused for the same reasons: an L1 user who has
   * not accepted the summary bid notice gets extensions.code SUMMARY_BID_NOTICE_REQUIRED, and a series
   * that has its bid is a Conflict with extensions.code ALREADY_BID.
   */
  saveSaleBidDraft?: Maybe<SaleBidDraft>;
  saveSellerBid: Deal;
  /** Saves the wire details clean and dirty prices, and sets prices to not visible. */
  saveWireDetailsPrices: PriceItem;
  /** Returns a job id for the list of loans selected for diligence */
  selectLoansForDiligence: Scalars['ID']['output'];
  sentWireTransfer: Deal;
  /** Sets wire details (bank/account info) on a deal month remittances item. Nil fields are left untouched; pass an empty string to clear a field. Uses optimistic locking via existing_version. */
  setRemittanceWireDetails: DealMonthRemittancesItem;
  /** Sets the wire details prices to visible for the buyer. Can only be used by the seller */
  setWireDetailsPricesVisible: PriceItem;
  /**
   * Exchange OAuth authorization code for session (BACKEND ONLY)
   * Tokens are stored in httpOnly cookies and never sent to client
   */
  ssoCallback: AuthResult;
  submitBid: Deal;
  submitFileHeaderMap: File;
  /** Tapestry: submit mapping corrections for a file (stub). */
  submitMappingCorrections: TapestryJobStatus;
  /** Sends referral email to the user information and to orsnn internal */
  submitReferral: Scalars['Boolean']['output'];
  /**
   * Submits your company's final bid on a series (round, structure and offering set), strictly
   * before the round's deadline, and deletes the series' draft. A submitted bid cannot be changed or
   * withdrawn: another submission on the series is a Conflict with extensions.code ALREADY_BID.
   */
  submitSaleBid?: Maybe<SaleBid>;
  /**
   * Submit a support request from the application.
   * The sessionId is from the client-side logger that tracks user activity.
   */
  submitSupportRequest: SubmitSupportRequestResponse;
  toggleCarveStipulation: DealCarve;
  /** Restore soft-archived loan tapes back into the default upload-history view. See ENG-2845. */
  unarchiveLoanTapes: ArchiveLoanTapesResponse;
  updateCarveStipulation: DealCarve;
  updateCollateralStatus: Scalars['Boolean']['output'];
  updateCustomStipulations: DealCarve;
  updateDealCarve: DealCarve;
  updateDiligenceStatus?: Maybe<Diligence>;
  updateFileTemplate: Document;
  /** Updates the status and note on a specific variance (e.g. acknowledge with a comment). Uses optimistic locking via expected_version. */
  updateRemittanceVarianceStatus: UpdateRemittanceVarianceStatusResponse;
  userManagementAddUserScope: UserManagementAddUserScopeResponse;
  /** UserManagement APIs */
  userManagementCreateUser: UserManagementCreateUserResponse;
  userManagementRemoveUserFromCompany: UserManagementRemoveUserFromCompanyResponse;
  userManagementUpdateUserInfo: UserManagementUpdateUserInfoResponse;
  userManagementUpdateUserRoles: UserManagementUpdateUserRolesResponse;
  userManagementUpdateUserScopes: UserManagementUpdateUserScopesResponse;
};


export type MutationAcceptBidArgs = {
  input: AcceptBidInput;
};


export type MutationAcknowledgeSaleDocumentArgs = {
  doc_type: SaleDocumentType;
  document_sha256: Scalars['String']['input'];
  relationship?: InputMaybe<SaleAcknowledgementRelationship>;
  sale_id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};


export type MutationAddCollateralNoteArgs = {
  input: AddCollateralNoteInput;
};


export type MutationAddDealMessageArgs = {
  input?: InputMaybe<CreateDealMessageInput>;
};


export type MutationAddDiligenceNoteArgs = {
  input?: InputMaybe<CreateDiligenceNoteInput>;
};


export type MutationAddRemittanceNoteArgs = {
  input: AddRemittanceNoteInput;
};


export type MutationAddUserSettingArgs = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationAddWireDetailsNoteArgs = {
  input: AddWireDetailsNoteInput;
};


export type MutationAdvanceDealArgs = {
  action: DealActionOptionType;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationApproveRemittanceRecordsArgs = {
  input: ApproveRemittanceRecordsInput;
};


export type MutationApproveSaleArgs = {
  sale_id: Scalars['ID']['input'];
};


export type MutationArchiveLoanTapesArgs = {
  input: ArchiveLoanTapesInput;
};


export type MutationArchivePoolsArgs = {
  input: ArchivePoolsInput;
};


export type MutationCancelTapestryJobArgs = {
  file_id: Scalars['ID']['input'];
};


export type MutationConfirmTapestryJobArgs = {
  file_id: Scalars['ID']['input'];
};


export type MutationConfirmWireTransferArgs = {
  input: ConfirmWireTransferInput;
};


export type MutationCreateDealCarveArgs = {
  input: CreateDealCarveInput;
};


export type MutationCreateListingArgs = {
  input: CreateListingInput;
};


export type MutationCreatePoolArgs = {
  input: CreatePoolInput;
};


export type MutationCreateProtectedDownloadArgs = {
  asReviewer?: InputMaybe<Scalars['Boolean']['input']>;
  documentId: Scalars['ID']['input'];
  piiNoticeAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  piiNoticeVersion?: InputMaybe<Scalars['String']['input']>;
  purpose: ProtectedDownloadPurpose;
};


export type MutationCreateSaleArgs = {
  input: CreateSaleInput;
};


export type MutationDecideSaleBidderArgs = {
  input: DecideSaleBidderInput;
};


export type MutationDeleteContractArgs = {
  contractId: Scalars['ID']['input'];
  contractVersion: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
};


export type MutationDeleteDealCarveArgs = {
  input: DeleteDealCarveInput;
};


export type MutationDeleteS3FileArgs = {
  assetClass?: InputMaybe<AssetClass>;
  fileName: Scalars['String']['input'];
  fileType: FileType;
  parentId: Scalars['ID']['input'];
};


export type MutationGetCollateralFileUploadUrlArgs = {
  input: CollateralFileUploadUrlInput;
};


export type MutationGetCollateralReportUrlArgs = {
  input: GetCollateralReportUrlInput;
};


export type MutationGetContractFileGetUrlArgs = {
  input: GetContractFileGetUrlInput;
};


export type MutationGetContractFilePostUrlArgs = {
  input: GetContractFilePostUrlInput;
};


export type MutationGetFilePostUrlArgs = {
  assetClass?: InputMaybe<AssetClass>;
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: FileType;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<ProductType>;
  qmMode?: InputMaybe<QmMode>;
};


export type MutationGetRemittanceTapePostUrlArgs = {
  input: GetRemittanceTapePostUrlInput;
};


export type MutationGetWireDetailsFileUploadUrlArgs = {
  input: WireDetailsFileUploadUrlInput;
};


export type MutationIngestFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLogSalePoolLoanTableEventArgs = {
  count: Scalars['Int']['input'];
  kind: SalePoolLoanTableEventKind;
  view_id: Scalars['ID']['input'];
};


export type MutationMarkCollateralReviewCompleteArgs = {
  input: MarkCollateralReviewCompleteInput;
};


export type MutationMarkDiligenceAcceptedArgs = {
  input: MarkDiligenceAcceptedInput;
};


export type MutationMarkDiligenceCompleteArgs = {
  input: MarkDiligenceCompleteInput;
};


export type MutationMarkDocumentReadyToSignArgs = {
  contractId: Scalars['ID']['input'];
  contractVersion: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  isReady: Scalars['Boolean']['input'];
};


export type MutationMarkNotificationReadArgs = {
  requestData: MarkReadRequest;
};


export type MutationMarkSettlementCompleteArgs = {
  input: MarkSettlementCompleteInput;
};


export type MutationOpenSalePoolLoanTableArgs = {
  offering_id: Scalars['ID']['input'];
  pii_notice_acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  pii_notice_version?: InputMaybe<Scalars['String']['input']>;
  sale_id: Scalars['ID']['input'];
  view_as?: InputMaybe<SaleBidderLevel>;
};


export type MutationPutNotificationPreferencesArgs = {
  requestData: PutPreferencesRequest;
};


export type MutationRejectRemittanceRecordsArgs = {
  input: RejectRemittanceRecordsInput;
};


export type MutationRejectTapestryJobArgs = {
  file_id: Scalars['ID']['input'];
};


export type MutationRemoveCollateralFileArgs = {
  input: RemoveCollateralFileRequest;
};


export type MutationRemoveWireDetailsFileArgs = {
  input: RemoveWireDetailsFileInput;
};


export type MutationRequestSaleAccessArgs = {
  sale_id: Scalars['ID']['input'];
};


export type MutationRetryTapestryJobArgs = {
  file_id: Scalars['ID']['input'];
};


export type MutationRunBidOptimizationArgs = {
  round: Scalars['Int']['input'];
  sale_id: Scalars['ID']['input'];
};


export type MutationSaveContractReferenceTextArgs = {
  buyerReferenceText: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  contractVersion: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  sellerReferenceText: Scalars['String']['input'];
};


export type MutationSaveContractSignatureArgs = {
  consentVerbiage: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  contractVersion: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  intentVerbiage: Scalars['String']['input'];
};


export type MutationSaveSaleBidDraftArgs = {
  input: SaveSaleBidDraftInput;
};


export type MutationSaveSellerBidArgs = {
  input: SaveSellerBidInput;
};


export type MutationSaveWireDetailsPricesArgs = {
  input: SaveWireDetailsPricesInput;
};


export type MutationSelectLoansForDiligenceArgs = {
  input: SelectDiligenceLoansInput;
};


export type MutationSentWireTransferArgs = {
  input: SentWireTransferInput;
};


export type MutationSetRemittanceWireDetailsArgs = {
  input: SetRemittanceWireDetailsInput;
};


export type MutationSetWireDetailsPricesVisibleArgs = {
  input: SetWireDetailsPricesVisibleInput;
};


export type MutationSsoCallbackArgs = {
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitBidArgs = {
  input: SubmitBidInput;
};


export type MutationSubmitFileHeaderMapArgs = {
  header_maps: Array<HeaderMapInput>;
  id: Scalars['ID']['input'];
};


export type MutationSubmitMappingCorrectionsArgs = {
  corrections: Scalars['JSONObject']['input'];
  file_id: Scalars['ID']['input'];
};


export type MutationSubmitReferralArgs = {
  input: SubmitReferralInput;
};


export type MutationSubmitSaleBidArgs = {
  input: SubmitSaleBidInput;
};


export type MutationSubmitSupportRequestArgs = {
  input: SubmitSupportRequestInput;
};


export type MutationToggleCarveStipulationArgs = {
  input: ToggleStipulationInput;
};


export type MutationUnarchiveLoanTapesArgs = {
  input: UnarchiveLoanTapesInput;
};


export type MutationUpdateCarveStipulationArgs = {
  input: UpdateStipulationInput;
};


export type MutationUpdateCollateralStatusArgs = {
  input: UpdateCollateralStatusInput;
};


export type MutationUpdateCustomStipulationsArgs = {
  input: UpdateCustomStipulationsInput;
};


export type MutationUpdateDealCarveArgs = {
  input: UpdateDealCarveInput;
};


export type MutationUpdateDiligenceStatusArgs = {
  diligenceStatus: DiligenceStatus;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileTemplateArgs = {
  id: Scalars['ID']['input'];
  isTemplate: Scalars['Boolean']['input'];
};


export type MutationUpdateRemittanceVarianceStatusArgs = {
  input: UpdateRemittanceVarianceStatusInput;
};


export type MutationUserManagementAddUserScopeArgs = {
  requestData: UserManagementAddUserScopeRequest;
};


export type MutationUserManagementCreateUserArgs = {
  requestData: UserManagementCreateUserRequest;
};


export type MutationUserManagementRemoveUserFromCompanyArgs = {
  requestData: UserManagementRemoveUserFromCompanyRequest;
};


export type MutationUserManagementUpdateUserInfoArgs = {
  requestData: UserManagementUpdateUserInfoRequest;
};


export type MutationUserManagementUpdateUserRolesArgs = {
  requestData: UserManagementUpdateUserRolesRequest;
};


export type MutationUserManagementUpdateUserScopesArgs = {
  requestData: UserManagementUpdateUserScopesRequest;
};

export type NewsArticle = {
  id: Scalars['String']['output'];
  news_category?: Maybe<Scalars['String']['output']>;
  news_source: NewsSource;
  publication_date: Scalars['DateTime']['output'];
  sentiment_label?: Maybe<NewsArticleSentimentLabel>;
  sentiment_score?: Maybe<Scalars['Float']['output']>;
  subject: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum NewsArticleField {
  category = 'category',
  id = 'id',
  publication_date_seconds = 'publication_date_seconds',
  sentiment_label = 'sentiment_label',
  sentiment_score = 'sentiment_score',
  source = 'source',
  subject = 'subject',
  summary = 'summary',
  url = 'url'
}

export enum NewsArticleSentimentLabel {
  ERROR = 'ERROR',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type NewsFilter = {
  field_name: NewsArticleField;
  operand?: InputMaybe<Scalars['String']['input']>;
  operandList?: InputMaybe<Array<Scalars['String']['input']>>;
  operator: FilterOperator;
};

export type NewsSort = {
  sort_direction?: InputMaybe<SortDirection>;
  sort_field?: InputMaybe<NewsArticleField>;
};

export enum NewsSource {
  ABA = 'ABA',
  CUNA = 'CUNA',
  CU_TODAY = 'CU_TODAY',
  FDIC = 'FDIC',
  FEDERAL_RESERVE = 'FEDERAL_RESERVE',
  MBA = 'MBA',
  NCUA = 'NCUA',
  OTHER = 'OTHER',
  US_TREASURY = 'US_TREASURY'
}

export type Note = {
  authorID: Scalars['ID']['output'];
  authorRole: DealMessageAuthorRole;
  buyerCompanyID: Scalars['ID']['output'];
  createdAt: Scalars['Long']['output'];
  dealID: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  loanID?: Maybe<Scalars['ID']['output']>;
  note: Scalars['String']['output'];
  noteID: Scalars['ID']['output'];
  offeringID?: Maybe<Scalars['String']['output']>;
  sellerCompanyID: Scalars['ID']['output'];
  updatedAt: Scalars['Long']['output'];
};

export enum NoteStatus {
  NEW = 'NEW',
  NONE = 'NONE',
  READ = 'READ'
}

export type NotesResponse = {
  files?: Maybe<Array<Maybe<FileWithNotes>>>;
  nextPaginationKey?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  content: ContentData;
  createdAt: Scalars['Int']['output'];
  notificationID: Scalars['String']['output'];
  readAt: Scalars['Int']['output'];
  sentAt: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userID: Scalars['String']['output'];
};

export type NotificationResponse = {
  content: Scalars['String']['output'];
  notificationMetadata: Notification;
};

/** Offering creation job with offering-specific metadata */
export type OfferingCreationJob = Job & {
  created_at: Scalars['Long']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  estimated_count: Scalars['Int']['output'];
  /** Common Job fields */
  job_id: Scalars['ID']['output'];
  job_type: JobType;
  /** Offering-specific fields */
  offering_name?: Maybe<Scalars['String']['output']>;
  pool_id?: Maybe<Scalars['ID']['output']>;
  processed_count: Scalars['Int']['output'];
  progress_percentage: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['Long']['output']>;
  status: JobStatusEnum;
  updated_at: Scalars['Long']['output'];
};

export enum OriginationType {
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT',
  INDIRECT_FINTECH = 'INDIRECT_FINTECH',
  MIXED = 'MIXED',
  N_A = 'N_A'
}

/** The pagination inputs.  Instead of an offset, we use a cursor to indicate where we want the page of results to start. */
export type Pagination = {
  /** The orsnn loan uuid that appeared at the end of the last page.  This is a 'tiebreaker' for the sorted value cursor. */
  cursor_id?: InputMaybe<Scalars['String']['input']>;
  /** The value in the last row of the last page for the column by which we sorted. */
  cursor_sorted_value?: InputMaybe<Scalars['String']['input']>;
  /** The offset of the first element in the page */
  offset?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export enum ParentType {
  COMPANY = 'COMPANY',
  DEAL = 'DEAL',
  LISTING = 'LISTING'
}

/** Pay mark for one payment month (same shape as loan-service getRemittancePaystrings). */
export type PayMarkByMonth = {
  pay_mark: Scalars['String']['output'];
  payment_month: Scalars['String']['output'];
};

export enum PerformanceClass {
  NON_PERFORMING = 'NON_PERFORMING',
  PERFORMING = 'PERFORMING',
  RE_PERFORMING = 'RE_PERFORMING',
  SUB_PERFORMING = 'SUB_PERFORMING'
}

/**
 * The FDIC's designation of a single loan as of a sale's Calculation Date. Distinct from
 * PerformanceClass, which labels a marketplace offering.
 */
export enum PerformanceStatus {
  NON_PERFORMING = 'NON_PERFORMING',
  PERFORMING = 'PERFORMING'
}

export type PerformanceSummary = {
  cash_flows: CashFlows;
  current_balance_cents: Scalars['Long']['output'];
  loan_count: Scalars['Int']['output'];
  max_age_months: Scalars['Int']['output'];
  max_borrower_credit_score: Scalars['Int']['output'];
  max_coupon_bps: Scalars['Int']['output'];
  max_current_balance_cents: Scalars['Long']['output'];
  max_dscr_bps: Scalars['Int']['output'];
  max_dti_bps: Scalars['Int']['output'];
  max_first_payment_date?: Maybe<Scalars['Date']['output']>;
  max_ltv_bps: Scalars['Int']['output'];
  max_maturity_date?: Maybe<Scalars['Date']['output']>;
  max_remaining_loan_terms_months: Scalars['Int']['output'];
  max_servicing_rate_bps: Scalars['Int']['output'];
  min_age_months: Scalars['Int']['output'];
  min_borrower_credit_score: Scalars['Int']['output'];
  min_coupon_bps: Scalars['Int']['output'];
  min_current_balance_cents: Scalars['Long']['output'];
  /**
   * DSCR / Non-QM subtype pool stats (ENG-2848). min/max/UPB-weighted-avg DSCR
   * in basis points; 0 for a portfolio with no DSCR loans (same contract as
   * wa_combined_ltv_bps) — t_dscr disambiguates.
   */
  min_dscr_bps: Scalars['Int']['output'];
  min_dti_bps: Scalars['Int']['output'];
  min_first_payment_date?: Maybe<Scalars['Date']['output']>;
  min_ltv_bps: Scalars['Int']['output'];
  min_maturity_date?: Maybe<Scalars['Date']['output']>;
  min_remaining_loan_terms_months: Scalars['Int']['output'];
  min_servicing_rate_bps: Scalars['Int']['output'];
  original_balance_cents: Scalars['Long']['output'];
  pct_asset_util?: Maybe<Scalars['Float']['output']>;
  pct_dscr: Scalars['Float']['output'];
  pct_non_qm: Scalars['Float']['output'];
  strat_age_months: Array<StratRow>;
  strat_asset_class: Array<StratRow>;
  strat_borrower_credit_score: Array<StratRow>;
  strat_current_balance_cents: Array<StratRow>;
  strat_dti: Array<StratRow>;
  strat_first_payment_date: Array<StratRow>;
  strat_interest_rate: Array<StratRow>;
  /**
   * Distribution of HELOC loans by lien position (1 = first, 2 = second
   * typical, 3+ = subordinated). HELOC-only — empty for non-HELOC portfolios.
   */
  strat_lien_position: Array<StratRow>;
  strat_loan_terms_months: Array<StratRow>;
  strat_ltv: Array<StratRow>;
  strat_net_rate: Array<StratRow>;
  strat_occupancy: Array<StratRow>;
  strat_original_balance_cents: Array<StratRow>;
  strat_product: Array<StratRow>;
  strat_property_description: Array<StratRow>;
  strat_property_year: Array<StratRow>;
  strat_purpose: Array<StratRow>;
  strat_remaining_loan_terms_months: Array<StratRow>;
  /** These states are sorted by number of loans, descending. */
  strat_state: Array<StratRow>;
  t_asset_util?: Maybe<Scalars['Int']['output']>;
  /**
   * Pool subtype counts and their share of loan_count: t_dscr = loans with
   * underwriting_type DSCR; t_non_qm = loans with qm_status NON_QM; t_asset_util =
   * loans with underwriting_type ASSET_UTIL — asset-depletion-qualified (ENG-3391).
   * Most ASSET_UTIL loans carry no dti_bps (deliberately absent, never a sentinel),
   * but a seller whose program computes an imputed-income DTI maps a real one, so
   * this is a qualification-method count, NOT a count of DTI-less loans. Since
   * ENG-3391, t_dscr's population may also include DTI-less rows (a DSCR override
   * on an asset-based row keeps its blank DTI). The DTI aggregates skip absent
   * values, so they cover an unstated subset of the pool; a DTI-coverage count is
   * tracked separately on the ticket. pct_* are percentages (0–100).
   * t_asset_util/pct_asset_util are nullable, unlike their siblings: null means
   * "not computed by the analytics service yet" (pre-cashflows-deploy), which must
   * render as absent — a fabricated 0 would claim a pool has no asset-depletion
   * loans when nothing counted them.
   */
  t_dscr: Scalars['Int']['output'];
  t_non_qm: Scalars['Int']['output'];
  wa_age_months: Scalars['Float']['output'];
  wa_borrower_credit_score: Scalars['Int']['output'];
  /**
   * Weighted-average Combined LTV (CLTV) in basis points. HELOC-only — zero
   * for non-HELOC portfolios since combined_ltv_bps is None on those loans.
   */
  wa_combined_ltv_bps: Scalars['Int']['output'];
  wa_coupon_bps: Scalars['Int']['output'];
  wa_current_balance_cents: Scalars['Long']['output'];
  /**
   * Weighted-average HELOC draw / repayment period in months, weighted by
   * current balance. Measured from ORIGINATION (contractual period length),
   * HELOC-only — zero for non-HELOC portfolios. Use for display/labeling
   * ("this pool averages a 10-year draw"), NOT for the phase boundary.
   */
  wa_draw_period_months: Scalars['Float']['output'];
  wa_dscr_bps: Scalars['Int']['output'];
  wa_dti_bps: Scalars['Int']['output'];
  wa_ltv_bps: Scalars['Int']['output'];
  wa_original_balance_cents: Scalars['Long']['output'];
  /**
   * HELOC-only balance-weighted remaining draw period: the weighted average of
   * (draw_period_months - age_months) over HELOC loans only. This is the value
   * to render the Draw → Repayment phase boundary on a months-from-now cashflow
   * chart. Do NOT derive it as wa_draw_period_months - wa_age_months:
   * wa_age_months is weighted over ALL loans while wa_draw_period_months is
   * HELOC-only, so that subtraction is wrong for mixed portfolios. Can be
   * negative if the balance-weighted pool has on average passed its draw
   * period; clamp to the visible axis as needed.
   */
  wa_remaining_draw_period_months: Scalars['Float']['output'];
  wa_remaining_loan_terms_months: Scalars['Float']['output'];
  wa_repayment_period_months: Scalars['Float']['output'];
  wa_servicing_rate_bps: Scalars['Int']['output'];
};


export type PerformanceSummaryCash_FlowsArgs = {
  conditionalDefaultRate: Scalars['Float']['input'];
  conditionalPrepaymentRate: Scalars['Float']['input'];
  daysDelay?: InputMaybe<Scalars['Int']['input']>;
  defaultAssumptionType?: InputMaybe<DefaultAssumptionType>;
  lossSeverityRate: Scalars['Float']['input'];
  marketYield?: InputMaybe<Scalars['Float']['input']>;
  prepaymentAssumptionType?: InputMaybe<PrepaymentAssumptionType>;
  rateType?: InputMaybe<RateType>;
  servicingRate?: InputMaybe<Scalars['Float']['input']>;
};

/** An offering's loans split by performance status. Book value is UPB. */
export type PerformanceTotals = {
  non_performing_book_value_cents: Scalars['Long']['output'];
  non_performing_loan_count: Scalars['Int']['output'];
  performing_book_value_cents: Scalars['Long']['output'];
  performing_loan_count: Scalars['Int']['output'];
};

export type PlaceBidCard = TimelineCard & {
  /** BidCard Fields */
  asset_class: AssetClass;
  /** Returns all bids and counterbids for this deal, with information about which side (buyer or seller) submitted each bid */
  bids: Array<DealBid>;
  /** Not meant for seller use. Will return an empty array */
  carves?: Maybe<Array<DealCarve>>;
  deal: Deal;
  documents: Array<TermsDocument>;
  is_participation_negotiable?: Maybe<Scalars['Boolean']['output']>;
  is_servicing_negotiable: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  participation_rate?: Maybe<Scalars['Int']['output']>;
  role: DealRole;
  servicing_fee_rate_bps?: Maybe<Scalars['Int']['output']>;
  servicing_preference: ServicingPreference;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

export type PlaceholderCard = TimelineCard & {
  deal: Deal;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
  /** Placeholders dont have other fields */
  tooltip?: Maybe<Scalars['String']['output']>;
};

/**
 * Pool represents a private collection of loans managed by a company.
 * Pools are non-public and used for internal portfolio management and analytics.
 */
export type Pool = {
  asset_class: AssetClass;
  company: UserCompany;
  created_date: Scalars['DateTime']['output'];
  /** Optional fields */
  has_cra?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Whether the pool has active public offerings. Deprecated — use
   * market_status, which distinguishes IN_MARKET / TRADING / TRADED /
   * OFF_MARKET. is_public == (market_status == IN_MARKET).
   * @deprecated Use market_status — is_public is equivalent to (market_status == IN_MARKET)
   */
  is_public: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  loan_count: Scalars['Int']['output'];
  /** Pool-specific operations */
  loans: Array<Loan>;
  /** Lifecycle status of the pool in the marketplace. */
  market_status: PoolMarketStatus;
  name: Scalars['String']['output'];
  origination_type: OriginationType;
  /** Performance metrics from analytics service */
  performance_summary: PerformanceSummary;
  state: ListingState;
  t_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  top_states?: Maybe<Array<Scalars['String']['output']>>;
  wa_borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  wa_coupon_bps?: Maybe<Scalars['Int']['output']>;
  wa_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_dti_bps?: Maybe<Scalars['Int']['output']>;
  wa_loan_age_months?: Maybe<Scalars['Int']['output']>;
  wa_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_original_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_remaining_loan_terms_months?: Maybe<Scalars['Float']['output']>;
};


/**
 * Pool represents a private collection of loans managed by a company.
 * Pools are non-public and used for internal portfolio management and analytics.
 */
export type PoolLoansArgs = {
  filters?: InputMaybe<Array<Filter>>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


/**
 * Pool represents a private collection of loans managed by a company.
 * Pools are non-public and used for internal portfolio management and analytics.
 */
export type PoolPerformance_SummaryArgs = {
  filters?: InputMaybe<Array<Filter>>;
};

/** Pool creation job with pool-specific metadata */
export type PoolCreationJob = Job & {
  asset_class?: Maybe<AssetClass>;
  created_at: Scalars['Long']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  estimated_count: Scalars['Int']['output'];
  has_filters?: Maybe<Scalars['Boolean']['output']>;
  /** Common Job fields */
  job_id: Scalars['ID']['output'];
  job_type: JobType;
  loan_count?: Maybe<Scalars['Int']['output']>;
  /** Pool-specific fields */
  pool_name?: Maybe<Scalars['String']['output']>;
  processed_count: Scalars['Int']['output'];
  progress_percentage: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['Long']['output']>;
  status: JobStatusEnum;
  updated_at: Scalars['Long']['output'];
};

/**
 * The lifecycle status of a pool in the marketplace, derived from the pool's
 * active offerings and their deal rooms. Precedence:
 * IN_MARKET > TRADING > TRADED > OFF_MARKET.
 */
export enum PoolMarketStatus {
  /** Pool has at least one active offering available for buyers to transact on. */
  IN_MARKET = 'IN_MARKET',
  /** Pool has no active offerings. */
  OFF_MARKET = 'OFF_MARKET',
  /** Pool has an accepted bid whose deal room is COMPLETE; no sibling offering qualifies as IN_MARKET or TRADING. */
  TRADED = 'TRADED',
  /** Pool has an accepted bid whose deal room is in settlement (PENDING_SETTLEMENT / WAIT_FOR_WIRE_TRANSFER / WIRE_TRANSFER_SENT). */
  TRADING = 'TRADING'
}

export enum PrepaymentAssumptionType {
  CPR = 'CPR',
  PSA = 'PSA'
}

export type Price = {
  buyer_price_cents?: Maybe<Scalars['Long']['output']>;
  /**
   * Long, not Int: a bid on a pool above $21,474,836.47 overflows 32-bit Int and
   * fails on serialize, erroring the whole query rather than just this field.
   */
  buyer_unpaid_balance_cents?: Maybe<Scalars['Long']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  rate_bps?: Maybe<Scalars['Int']['output']>;
  transfer_amount?: Maybe<Scalars['Int']['output']>;
  unpaid_balance?: Maybe<Scalars['Float']['output']>;
};

export type PriceItem = {
  buyerCompany: Company;
  cleanPriceCents?: Maybe<Scalars['Long']['output']>;
  deal: Deal;
  dirtyPriceCents?: Maybe<Scalars['Long']['output']>;
  isVisibleToBuyer: Scalars['Boolean']['output'];
  saverCompany: Company;
  sellerCompany: Company;
  updatedAt: Scalars['DateTime']['output'];
};

export type PriceYieldMatrix = {
  spread_matrix?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  yield_matrix?: Maybe<Array<Array<Scalars['Float']['output']>>>;
};

export enum PricingType {
  NONE = 'NONE',
  PUBLISHED = 'PUBLISHED',
  RESERVED = 'RESERVED'
}

export type PrivateCompany = Company & {
  /** Form5300 LLM Analysis fields */
  form5300LLMAnalysis?: Maybe<LoanData>;
  /** PrivateCompany fields */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  regulatory_agency?: Maybe<Agency>;
  regulatory_metrics?: Maybe<RegulatoryMetrics>;
  regulatory_number: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProcessingReport = {
  duplicate_count?: Maybe<Scalars['Int']['output']>;
  duplicate_records_csv_url?: Maybe<Scalars['String']['output']>;
  duplicate_records_excel_url?: Maybe<Scalars['String']['output']>;
  failed_count?: Maybe<Scalars['Int']['output']>;
  failed_records_csv_url?: Maybe<Scalars['String']['output']>;
  failed_records_excel_url?: Maybe<Scalars['String']['output']>;
  flagged_count?: Maybe<Scalars['Int']['output']>;
  flagged_records_csv_url?: Maybe<Scalars['String']['output']>;
  flagged_records_excel_url?: Maybe<Scalars['String']['output']>;
  new_count?: Maybe<Scalars['Int']['output']>;
  new_records_csv_url?: Maybe<Scalars['String']['output']>;
  new_records_excel_url?: Maybe<Scalars['String']['output']>;
  updated_count?: Maybe<Scalars['Int']['output']>;
  updated_records_csv_url?: Maybe<Scalars['String']['output']>;
  updated_records_excel_url?: Maybe<Scalars['String']['output']>;
};

export type ProcessingStatus = {
  activeZipFileName: Scalars['String']['output'];
  customerPercentage: Scalars['Float']['output'];
  diligenceInProgress: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  expectedFileCount: Scalars['Int']['output'];
  nFilesCompleted: Scalars['Int']['output'];
  zipProcessingStartTime?: Maybe<Scalars['String']['output']>;
};

export enum ProductType {
  ARM = 'ARM',
  FIXED = 'FIXED'
}

export type ProtectedDownload = {
  downloadId: Scalars['ID']['output'];
  /** After this the file can no longer be opened. */
  expiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  purpose: ProtectedDownloadPurpose;
  /** Short-lived link to the protected file. A bearer credential: returned only to the caller. */
  url: Scalars['String']['output'];
  urlExpiresAt: Scalars['DateTime']['output'];
};

/**
 * DOWNLOAD is a file the bidder saves. VIEW is a copy issued only for the in-app viewer; it expires
 * within the hour.
 */
export enum ProtectedDownloadPurpose {
  DOWNLOAD = 'DOWNLOAD',
  VIEW = 'VIEW'
}

export type PublicCompany = Company & {
  regulatory_metrics?: Maybe<RegulatoryMetrics>;
  type: Scalars['String']['output'];
};

export type PublicListing = Listing & {
  /** Flag determining if this deal can be marketed to banks. */
  allow_banks: Scalars['Boolean']['output'];
  /** Flag determining if this loan pool can be marketed to credit unions. */
  allow_credit_unions: Scalars['Boolean']['output'];
  /** Flag determining if this loan pool can be marketed to non depository institutions. */
  allow_private_capital: Scalars['Boolean']['output'];
  asset_class: AssetClass;
  company: Company;
  created_date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  execution_type: ExecutionType;
  /** When the offering leaves the marketplace. Null for a pool-backed listing, which does not expire. */
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  has_cra?: Maybe<Scalars['Boolean']['output']>;
  /** Listing Implemented Fields */
  id: Scalars['ID']['output'];
  /** This field is the deal id in progress for the listing for the user's company */
  in_progress_deal_id?: Maybe<Scalars['String']['output']>;
  is_participation_negotiable?: Maybe<Scalars['Boolean']['output']>;
  is_servicing_negotiable?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date: Scalars['DateTime']['output'];
  loan_count?: Maybe<Scalars['Int']['output']>;
  minimum_carve_cents?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  origination_type: OriginationType;
  /** This field should be ignored if execution type is "all or nothing". */
  participation_rate?: Maybe<Scalars['Int']['output']>;
  performance_class: PerformanceClass;
  /** This field cannot be filtered on, since it is a public listing, and not all potential buyers have access to the seller's loans. */
  performance_summary: PerformanceSummary;
  /** If PricingType is PUBLISHED, this will return the published rate.  If PricingType is RESERVED or NO, this will return null. */
  pricing_rate_bps?: Maybe<Scalars['Int']['output']>;
  pricing_type?: Maybe<PricingType>;
  provided_name?: Maybe<Scalars['String']['output']>;
  /**
   * The FDIC sale this offering is a pool of; null on a marketplace offering. Raw loan-data
   * exports are withheld for an offering in a sale.
   */
  sale_id?: Maybe<Scalars['ID']['output']>;
  servicing_fee_rate_bps?: Maybe<Scalars['Int']['output']>;
  servicing_preference: ServicingPreference;
  state: ListingState;
  t_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  top_states?: Maybe<Array<Scalars['String']['output']>>;
  wa_borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  wa_coupon_bps?: Maybe<Scalars['Int']['output']>;
  wa_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_dti_bps?: Maybe<Scalars['Int']['output']>;
  wa_loan_age_months?: Maybe<Scalars['Int']['output']>;
  wa_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_original_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_remaining_loan_terms_months?: Maybe<Scalars['Float']['output']>;
};

export type PutPreferencesRequest = {
  emailOptIn: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  textOptIn: Scalars['Boolean']['input'];
};

export type PutPreferencesResponse = {
  success: Scalars['Boolean']['output'];
};

export enum QmMode {
  MIXED = 'MIXED',
  NON_QM = 'NON_QM',
  QM = 'QM'
}

/** Whether a residential loan satisfied Qualified Mortgage underwriting (ENG-2825). */
export enum QmStatus {
  NON_QM = 'NON_QM',
  QM = 'QM'
}

export type Query = {
  /** Retrieves a single loan by the account and company id. If you dont have access an error will be thrown */
  account?: Maybe<Loan>;
  autoMapFields: AutoMapFieldsResult;
  calculateBidPrice: Price;
  collateralNotes: NotesResponse;
  /** Returns jobs for the current user's company with optional filtering */
  companyJobs: CompanyJobsResponse;
  /** The sales the caller's company sells or bids in, newest first. Omit `role` for both. */
  companySales: Array<SaleView>;
  /** Retrieves the deal for your company. This will fail if you try to get a deal that doesn't belong to your company. Can be buyer or seller */
  deal?: Maybe<Deal>;
  dealMessages?: Maybe<DealMessageList>;
  diligenceNotes?: Maybe<DiligenceNoteList>;
  /** Discover SSO provider by email domain */
  discoverSSOProvider: SsoDiscoveryResult;
  /** Retrieves feature flags to control feature availability and versions */
  featureFlags: Array<FeatureFlag>;
  /** Retrieves all months of remittance records for given account_ids in a deal, grouped by account_id. User must be deal buyer or seller. */
  getAccountRemittanceRecords: GetAccountRemittanceRecordsResponse;
  /** Retrieves variances for specific accounts within a remittance upload. */
  getAccountRemittanceVariances: GetAccountRemittanceVariancesResponse;
  /** Gets a download URL for a collateral file (leave off loan id to get a zip file) */
  getCollateralFileDownloadURL: CollateralFileDownloadUrlResponse;
  /** Contract queries */
  getContractsForDeal: Array<Maybe<ContractItem>>;
  getDealMonthRemittances: GetDealMonthRemittancesResponse;
  /** Retrieves aggregated remittance summaries by payment month for a deal. User must be deal buyer or seller. */
  getDealRemittanceSummaries: GetDealRemittanceSummariesResponse;
  /** Retrieves completed deals where the user's company is the seller and the accepted bid has servicing retained (deals with remittances). */
  getDealsWithRemittances: Array<Deal>;
  /** Gets the diligence AI analysis for a specific deal */
  getDiligenceAI: DiligenceResponse;
  /** With an s3 key and version id, returns the uuid of the file in our database.  If the file doesn't exist, returns null. */
  getFileUuid: Scalars['String']['output'];
  /** Gets file metadata about all collateral files associated with a deal */
  getMultipleCollateralFilesMetadata: MultipleCollateralFilesMetadataResponse;
  /** Retrieves remittance notes for a deal, loanID, and month */
  getRemittanceNotes: GetRemittanceNotesResponse;
  getSelectDiligenceStatus: DiligenceBatchStatus;
  /** Retrieves all completed servicing deals the user's company is involved in: as seller (accepted bid has servicing retained) or as buyer. Used for the remittance default view (one row per deal, link to deal/deal_id for latest month). */
  getServicedDeals: Array<Deal>;
  /** Gets Collateral metadata about a specific file in a deal */
  getSingleCollateralFileMetadata: SingleCollateralFileMetadataResponse;
  /** Retrieves remittance records for a deal and single month (or latest approved month). Use deal_id; optionally payment_month, account_ids or filters, and pagination. */
  getSingleMonthRemittanceRecords: GetSingleMonthRemittanceRecordsResponse;
  /** Retrieves remittance records for a specific upload with optional filters and pagination. Returns records, upload status, and optional summary. */
  getUploadRemittanceRecords: GetUploadRemittanceRecordsResponse;
  /** Retrieves all detected variances for a remittance upload with cursor-based pagination. */
  getUploadRemittanceVariances: GetUploadRemittanceVariancesResponse;
  /** Gets the list of valid terms for given keyword fields */
  getValidTerms: Array<ValidTermsResult>;
  /** Gets the presigned download url for a wire details file */
  getWireDetailsFileDownloadURL: WireDetailsFileDownloadUrlResponse;
  listCollateralReports: ListCollateralReportsResponse;
  marketData: MarketData;
  /**
   * Retrieve one offering owned by the caller's company, with every owner-only field unmasked.
   * Fails with FORBIDDEN for an offering that belongs to another company.
   */
  myOffering: UserCompanyListing;
  /**
   * Whether you hold an active reviewer grant on a sale that is CREATING, PENDING_APPROVAL or OPEN.
   * It does not say createProtectedDownload(asReviewer) will succeed: that also refuses once the
   * sale's access cut-off has passed, and refuses a user with no company.
   */
  mySaleReviewerAccess: SaleReviewerAccess;
  newsArticles: Array<NewsArticle>;
  notificationPreferences: GetPreferencesResponse;
  /** Every OPEN sale, newest first, as the caller's company sees it: the sales index. */
  openSales: Array<SaleAnnouncement>;
  /** One sale as the caller's company sees it, or null when it does not exist or the company cannot see it. */
  sale?: Maybe<SaleView>;
  /**
   * What you may see in an FDIC sale right now, for the sale page's gating: the request button, the
   * document click-throughs, and the L1 and L2 documents.
   */
  saleAccess?: Maybe<SaleAccess>;
  /**
   * The text of a sale document to show before acknowledgeSaleDocument, with the version and
   * document_sha256 to acknowledge it with. api serves PEC_SUMMARY and SUMMARY_BID_NOTICE and refuses
   * the other types: the client holds the CA. Any signed-in user whose company can see the sale reads
   * the PEC summary, before any access request, as it precedes Request Access (Exhibit 6). The
   * SUMMARY_BID_NOTICE is for the sale's seller and its approved bidders, and refused to anyone else.
   * Null when the sale does not exist or you cannot see it.
   */
  saleAcknowledgementDocument?: Maybe<SaleAcknowledgementDocument>;
  /**
   * Your company's drafts in an FDIC sale, one per bid series (round, structure and offering set).
   * No other company, the seller included, can read them.
   */
  saleBidDrafts: Array<SaleBidDraft>;
  /**
   * The Exhibit 16 bid day reports of one of a round's stored optimization runs, as one workbook.
   * Omit `version` for the round's latest run. For the sale's seller, once the round has unsealed.
   */
  saleBidReport?: Maybe<SaleBidReport>;
  /** Every company that has requested access to your company's sale, whatever its status. Seller only. */
  saleBidders: Array<SaleBidder>;
  /**
   * An FDIC sale's submitted bids, never drafts. A bidder gets its own; the seller gets every bid of
   * the rounds that have unsealed, and a Sealed error while none has.
   */
  saleBids: Array<SaleBid>;
  /**
   * The creation job of one of the caller's company's sales. COMPLETED means the sale is built:
   * PENDING_APPROVAL, or OPEN once approved.
   * When loan-service finds no job row (a stale read just after creation, or a row past its TTL), the
   * job comes from the sale's status, with a FAILED sale's failure_reason as its error_message.
   */
  saleCreationJob?: Maybe<SaleCreationJob>;
  /**
   * The sale's data room as a folder tree: sale, sale key, pool, asset. For whoever saleOfferings
   * admits: the seller gets documents of both levels, and a bidder those its level admits. Anyone else
   * gets an Authorization error. Documents carry no URL.
   * `view_as` is the seller's preview of a bidder's tree: L1 is what an L1 bidder gets, L2 the full
   * tree. From anyone but the seller it is refused.
   */
  saleDocuments: SaleDataRoom;
  /**
   * The sale's offerings in the order their pools were chosen, leaving out archived offerings and any
   * not yet built. For the sale's seller, and, while the sale is OPEN and through its last bid deadline, for a bidder approved at L1 or above
   * whose user has accepted the confidentiality agreement and the PEC summary. Anyone else gets an Authorization error.
   */
  saleOfferings: Array<SaleOfferingView>;
  /**
   * The distinct values of each of a pool's fields, for the loan table's filter options. Admits and
   * refuses callers as salePoolLoans does; a field the caller's level may not list (a PII field
   * below L2) is refused with code FORBIDDEN. Each call is recorded in the audit log.
   */
  salePoolLoanTerms: Array<ValidTermsResult>;
  /**
   * One page of a pool's loans, for whoever saleOfferings admits: the seller at L2 (or the level it
   * previews with view_as), a bidder at its own level. The level decides the PII fields, which are
   * null below L2, and the fields the page may be filtered and sorted by: allowed_filter_fields and
   * allowed_sort_fields; any other is refused with code FORBIDDEN. Unsorted is by account_id. A
   * bidder needs view_id, from openSalePoolLoanTable, and view_jti, the jti the key service's /view
   * issued for it; the key service must confirm on every page that they name a live session of the
   * caller's for this sale's pool at the level served, or the page is refused with code FORBIDDEN
   * (reason view_session_invalid), or ACCESS_REVOKED for a revocation. At L2 a bidder must also
   * send pii_notice_acknowledged: true and pii_notice_version on every page, as
   * openSalePoolLoanTable takes them; without both it is refused with code PII_NOTICE_REQUIRED. The
   * seller sends none of these.
   * A bidder whose user, company, sale, pool loan table or view is revoked in IRM is refused with
   * code ACCESS_REVOKED and the revocation's reason. Pages by offset: page_size from 1 to 200, and
   * the cursor fields of Pagination are refused. A caller who may not read the sale's offerings
   * (neither its seller nor a bidder at L1 or above through its last bid deadline, a missing sale
   * and a bidder's view_as included) is refused with code FORBIDDEN and reason sale_access_denied,
   * and a pool that is not one of the sale's live offerings with code FORBIDDEN and reason
   * pool_not_readable. Each page is recorded in the audit log.
   */
  salePoolLoans: SalePoolLoanPage;
  /**
   * The latest stored valuation of each of the sale's pools, in the order the pools were chosen, or
   * of the one pool with `fdic_pool_number`. A pool with no valuation is left out. For the sale's
   * seller.
   */
  salePoolValuations: Array<SalePoolValuation>;
  /**
   * Exhibit 6 Attachment D, the Special PII Notice to show before each Level 2 open, with the
   * version to send as piiNoticeVersion when the user accepts it. For a user who holds Level 2
   * access to an open sale: an approved bidder, with the CA and the PEC summary, before the sale's
   * last bid deadline. Refused to anyone else, the sale's seller and its FDIC reviewers included,
   * who open Level 2 data without the notice.
   */
  specialPiiNotice: SpecialPiiNotice;
  /** Tapestry: status of a file processing job (stub). */
  tapestryJobStatus: TapestryJobStatus;
  user: User;
  /** UserManagement APIs */
  userManagementGetUser: UserManagementGetUserResponse;
  userManagementListCompanyPermissions: UserManagementListCompanyPermissionsResponse;
  userManagementListCompanyUserPermissions: UserManagementListCompanyUserPermissionsResponse;
  /** notification APIs */
  userNotifications: GetUserNotificationsResponse;
};


export type QueryAccountArgs = {
  account_id: Scalars['ID']['input'];
  company_id: Scalars['ID']['input'];
};


export type QueryAutoMapFieldsArgs = {
  input: AutoMapFieldsInput;
};


export type QueryCalculateBidPriceArgs = {
  input: CalculateBidPriceInput;
};


export type QueryCollateralNotesArgs = {
  input: CollateralNotesInput;
};


export type QueryCompanyJobsArgs = {
  job_type?: InputMaybe<JobType>;
  statuses?: InputMaybe<Array<JobStatusEnum>>;
};


export type QueryCompanySalesArgs = {
  role?: InputMaybe<SaleRole>;
};


export type QueryDealArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDealMessagesArgs = {
  deal_id: Scalars['ID']['input'];
  pagination?: InputMaybe<DealMessagePaginationInput>;
};


export type QueryDiligenceNotesArgs = {
  diligence_id: Scalars['ID']['input'];
  pagination?: InputMaybe<DiligenceNotePaginationInput>;
};


export type QueryDiscoverSsoProviderArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetAccountRemittanceRecordsArgs = {
  input: GetAccountRemittanceRecordsInput;
};


export type QueryGetAccountRemittanceVariancesArgs = {
  input: GetAccountRemittanceVariancesInput;
};


export type QueryGetCollateralFileDownloadUrlArgs = {
  input: CollateralFileDownloadUrlInput;
};


export type QueryGetContractsForDealArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryGetDealMonthRemittancesArgs = {
  input: GetDealMonthRemittancesInput;
};


export type QueryGetDealRemittanceSummariesArgs = {
  input: GetDealRemittanceSummariesInput;
};


export type QueryGetDiligenceAiArgs = {
  input: DiligenceInput;
};


export type QueryGetFileUuidArgs = {
  input: GetFileUuidInput;
};


export type QueryGetMultipleCollateralFilesMetadataArgs = {
  input: MultipleCollateralFilesMetadataInput;
};


export type QueryGetRemittanceNotesArgs = {
  input: GetRemittanceNotesInput;
};


export type QueryGetSelectDiligenceStatusArgs = {
  input: GetSelectDiligenceStatusInput;
};


export type QueryGetSingleCollateralFileMetadataArgs = {
  input: SingleCollateralFileMetadataInput;
};


export type QueryGetSingleMonthRemittanceRecordsArgs = {
  input: GetSingleMonthRemittanceRecordsInput;
};


export type QueryGetUploadRemittanceRecordsArgs = {
  input: GetUploadRemittanceRecordsInput;
};


export type QueryGetUploadRemittanceVariancesArgs = {
  input: GetUploadRemittanceVariancesInput;
};


export type QueryGetValidTermsArgs = {
  input: GetValidTermsInput;
};


export type QueryGetWireDetailsFileDownloadUrlArgs = {
  input: WireDetailsFileDownloadUrlInput;
};


export type QueryListCollateralReportsArgs = {
  input: ListCollateralReportsInput;
};


export type QueryMyOfferingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMySaleReviewerAccessArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QueryNewsArticlesArgs = {
  filters?: InputMaybe<Array<NewsFilter>>;
  pagination?: InputMaybe<Pagination>;
  sort: NewsSort;
};


export type QuerySaleArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleAccessArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleAcknowledgementDocumentArgs = {
  doc_type: SaleDocumentType;
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleBidDraftsArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleBidReportArgs = {
  round: Scalars['Int']['input'];
  sale_id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySaleBiddersArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleBidsArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleCreationJobArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySaleDocumentsArgs = {
  sale_id: Scalars['ID']['input'];
  view_as?: InputMaybe<SaleBidderLevel>;
};


export type QuerySaleOfferingsArgs = {
  sale_id: Scalars['ID']['input'];
};


export type QuerySalePoolLoanTermsArgs = {
  fields: Array<FilterableField>;
  offering_id: Scalars['ID']['input'];
  pii_notice_acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  pii_notice_version?: InputMaybe<Scalars['String']['input']>;
  sale_id: Scalars['ID']['input'];
  view_as?: InputMaybe<SaleBidderLevel>;
  view_id?: InputMaybe<Scalars['ID']['input']>;
  view_jti?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalePoolLoansArgs = {
  filters?: InputMaybe<Array<Filter>>;
  offering_id: Scalars['ID']['input'];
  pagination: Pagination;
  pii_notice_acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  pii_notice_version?: InputMaybe<Scalars['String']['input']>;
  sale_id: Scalars['ID']['input'];
  sort?: InputMaybe<SalePoolLoanSort>;
  view_as?: InputMaybe<SaleBidderLevel>;
  view_id?: InputMaybe<Scalars['ID']['input']>;
  view_jti?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalePoolValuationsArgs = {
  fdic_pool_number?: InputMaybe<Scalars['String']['input']>;
  sale_id: Scalars['ID']['input'];
};


export type QueryTapestryJobStatusArgs = {
  file_id: Scalars['ID']['input'];
};


export type QueryUserManagementGetUserArgs = {
  requestData: UserManagementGetUserRequest;
};


export type QueryUserManagementListCompanyPermissionsArgs = {
  requestData: UserManagementListCompanyPermissionsRequest;
};


export type QueryUserManagementListCompanyUserPermissionsArgs = {
  requestData: UserManagementListCompanyUserPermissionsRequest;
};

export enum RateType {
  RiskFree = 'RiskFree',
  Sofr = 'Sofr'
}

/**
 * Regulatory Metrics ranking the company's performance percentiles in various categories.
 * Each rank is 1-100, or null when the company does not report that metric and so is not ranked on it.
 */
export type RegulatoryMetrics = {
  allowance_total_loans_rank?: Maybe<Scalars['Int']['output']>;
  charge_off_ratio_rank?: Maybe<Scalars['Int']['output']>;
  delinquency_rank?: Maybe<Scalars['Int']['output']>;
  efficiency_ratio_rank?: Maybe<Scalars['Int']['output']>;
  expense_ratio_rank?: Maybe<Scalars['Int']['output']>;
  iea_total_assets_rank?: Maybe<Scalars['Int']['output']>;
  loans_shares_rank?: Maybe<Scalars['Int']['output']>;
  net_worth_ratio_rank?: Maybe<Scalars['Int']['output']>;
  regulatory_agency: Agency;
  roa_rank?: Maybe<Scalars['Int']['output']>;
  roe_rank?: Maybe<Scalars['Int']['output']>;
};

/** Input for rejecting a remittance tape upload. Only the deal seller may reject; upload must be PENDING. */
export type RejectRemittanceRecordsInput = {
  /** ID of the remittance upload to reject */
  upload_id: Scalars['ID']['input'];
};

/**
 * Remittance record type
 * Matches remittance record storage; grouped like RemittanceRecordItem. Includes pay_mark and DateTime variants for timestamps/dates.
 */
export type RemittanceRecord = {
  account_id: Scalars['ID']['output'];
  accrued_unpaid_interest_cents?: Maybe<Scalars['Long']['output']>;
  accrued_unpaid_interest_participation_cents?: Maybe<Scalars['Long']['output']>;
  bankruptcy: Scalars['Boolean']['output'];
  /** Bankruptcy chapter when provided (e.g. "7", "13", "11") */
  bankruptcy_chapter?: Maybe<Scalars['String']['output']>;
  buyer_company_id: Scalars['ID']['output'];
  charge_off: Scalars['Boolean']['output'];
  charge_off_amount_cents?: Maybe<Scalars['Long']['output']>;
  charge_off_amount_participation_cents?: Maybe<Scalars['Long']['output']>;
  charge_off_date_seconds?: Maybe<Scalars['Long']['output']>;
  /** Charge-off */
  charge_off_threshold_days?: Maybe<Scalars['Long']['output']>;
  /** Timestamps (DateTime representation) */
  created_at: Scalars['DateTime']['output'];
  current_balance_cents?: Maybe<Scalars['Long']['output']>;
  days_past_due?: Maybe<Scalars['Long']['output']>;
  defaults_cents?: Maybe<Scalars['Long']['output']>;
  defaults_participation_cents?: Maybe<Scalars['Long']['output']>;
  interest_cents: Scalars['Long']['output'];
  interest_participation_cents?: Maybe<Scalars['Long']['output']>;
  interest_rate_basis_points?: Maybe<Scalars['Long']['output']>;
  last_payment_date_seconds?: Maybe<Scalars['Long']['output']>;
  losses_cents?: Maybe<Scalars['Long']['output']>;
  losses_participation_cents?: Maybe<Scalars['Long']['output']>;
  /** Pay mark per payment month for this account (loan-service format: month -> pay_mark). */
  marks_by_month?: Maybe<Array<PayMarkByMonth>>;
  /** Maturity date (DateTime representation of maturity_date_seconds) */
  maturity_date?: Maybe<Scalars['DateTime']['output']>;
  /** Core remittance fields (from tape template) */
  maturity_date_seconds?: Maybe<Scalars['Long']['output']>;
  next_due_date_seconds?: Maybe<Scalars['Long']['output']>;
  /** Next payment/due date (DateTime representation of next_due_date_seconds) */
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  /** Identifiers */
  offering_id: Scalars['ID']['output'];
  original_balance_cents?: Maybe<Scalars['Long']['output']>;
  /** Participation (investor-share) */
  participation_rate_basis_points?: Maybe<Scalars['Long']['output']>;
  /** Optional payment mark identifier (single month) */
  pay_mark?: Maybe<Scalars['String']['output']>;
  payment_cents?: Maybe<Scalars['Long']['output']>;
  /** Payment month in format YYYY-MM */
  payment_month: Scalars['String']['output'];
  payment_participation_cents?: Maybe<Scalars['Long']['output']>;
  prepayments_cents?: Maybe<Scalars['Long']['output']>;
  prepayments_participation_cents?: Maybe<Scalars['Long']['output']>;
  principal_cents: Scalars['Long']['output'];
  principal_participation_cents?: Maybe<Scalars['Long']['output']>;
  repossession: Scalars['Boolean']['output'];
  seller_company_id: Scalars['ID']['output'];
  servicing_cents: Scalars['Long']['output'];
  starting_balance_cents?: Maybe<Scalars['Long']['output']>;
  /** Status flags (tape binary 0/1 columns) */
  tdr: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  upload_id: Scalars['ID']['output'];
  /**
   * Variance codes detected on this record for the upload's payment month. Empty when no
   * variances were detected. Joined server-side from the same variance store that
   * `getUploadRemittanceVariances` / `getAccountRemittanceVariances` read from, so the
   * datatable can render chips inline without a second round-trip.
   *
   * Note: during a rolling api deploy older instances may omit this field; the client
   * should treat a missing value as `[]`.
   */
  variance_codes: Array<VarianceCode>;
  /** Audit */
  version?: Maybe<Scalars['Long']['output']>;
};

/** A single detected anomaly on one remittance record. */
export type RemittanceRecordVariance = {
  account_id: Scalars['String']['output'];
  buyer_company_id: Scalars['ID']['output'];
  created_at_milliseconds: Scalars['Long']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offering_id: Scalars['ID']['output'];
  payment_month: Scalars['String']['output'];
  seller_company_id: Scalars['ID']['output'];
  status: VarianceStatus;
  updated_at_milliseconds: Scalars['Long']['output'];
  upload_id: Scalars['ID']['output'];
  variance_code: VarianceCode;
  version: Scalars['Int']['output'];
};

export type RemittanceTapePostFormField = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RemittanceTapePostUrlResponse = {
  /** Optional: URL expiry in seconds; for display only. */
  expiresInSeconds?: Maybe<Scalars['Int']['output']>;
  /** Form field name the client must use for the file body (e.g. 'file'). */
  fileFieldName: Scalars['String']['output'];
  /**
   * Form field names and values for the POST (key, policy, x-amz-signature,
   * x-amz-meta-* from metadata, etc.). UI appends these to FormData, then the file.
   */
  formFields: Array<RemittanceTapePostFormField>;
  /**
   * S3 object metadata to be stored on the uploaded object (legacy: Metadata).
   * Backend must encode these into the POST so they are sent as x-amz-meta-* (e.g.
   * x-amz-meta-deal-id, x-amz-meta-payment-month). Lambda reads these from the
   * object to call loan-service. Keys match legacy: deal-id, payment-month,
   * offering-id, buyer-company-id, seller-company-id, file-name, content-type,
   * user-id, uploaded-at, etc.
   */
  metadata: Array<RemittanceTapePostFormField>;
  /** URL to POST the file to (S3 bucket or API endpoint). Legacy equivalent: URL (PUT). */
  postUrl: Scalars['String']['output'];
  /** Server-generated upload ID. Included in the S3 key so the lambda creates records under this id; client uses it to approve the upload and to fetch by upload (e.g. getUploadRemittanceRecords). */
  upload_id: Scalars['String']['output'];
};

/** Remittance tape upload row (seller view). Only sellers see this list; buyers use loan-service remittance data. */
export type RemittanceTapeUpload = {
  buyer_company_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  deal_id: Scalars['ID']['output'];
  file_name: Scalars['String']['output'];
  /** File status in API (mapping / persistence pipeline, same as loan tapes). From API DDB file table. */
  file_state: FileState;
  id: Scalars['ID']['output'];
  offering_id: Scalars['ID']['output'];
  payment_month: Scalars['String']['output'];
  seller_company_id: Scalars['ID']['output'];
  /** Loan-service remittance approval status (PENDING/APPROVED/REJECTED). Null when upload not yet in loan-service. */
  upload_status?: Maybe<RemittancesUploadStatus>;
};

/**
 * Aggregated totals for a remittance upload. Every money field is exposed in two variants:
 * `*_cents` (or `*_participation_cents`) for investor-share, and `*_full_cents` for 100% tape.
 * `total_fees_cents` is the single exception — it is full-only because the servicer keeps 100%
 * of servicing fees, so there is no meaningful investor aggregate. Investor-share fields sum
 * per-record participations, which respects non-uniform per-loan participation rates within a
 * deal (consumers do NOT need to scale by a deal-wide rate).
 */
export type RemittancesSummary = {
  delinquent_count?: Maybe<Scalars['Long']['output']>;
  ending_balance_cents?: Maybe<Scalars['Long']['output']>;
  ending_balance_participation_cents?: Maybe<Scalars['Long']['output']>;
  loan_count?: Maybe<Scalars['Long']['output']>;
  prepayment_count?: Maybe<Scalars['Long']['output']>;
  starting_balance_cents?: Maybe<Scalars['Long']['output']>;
  starting_balance_participation_cents?: Maybe<Scalars['Long']['output']>;
  total_defaults_cents?: Maybe<Scalars['Long']['output']>;
  total_defaults_participation_cents?: Maybe<Scalars['Long']['output']>;
  /** Full (100% tape) totals. total_fees_cents is full-only; servicer keeps 100%. */
  total_fees_cents?: Maybe<Scalars['Long']['output']>;
  total_interest_cents?: Maybe<Scalars['Long']['output']>;
  total_interest_full_cents?: Maybe<Scalars['Long']['output']>;
  total_losses_cents?: Maybe<Scalars['Long']['output']>;
  total_losses_participation_cents?: Maybe<Scalars['Long']['output']>;
  total_payments_cents?: Maybe<Scalars['Long']['output']>;
  total_payments_full_cents?: Maybe<Scalars['Long']['output']>;
  total_prepayments_cents?: Maybe<Scalars['Long']['output']>;
  total_prepayments_participation_cents?: Maybe<Scalars['Long']['output']>;
  /** Participation (investor-share) totals. */
  total_principal_cents?: Maybe<Scalars['Long']['output']>;
  total_principal_full_cents?: Maybe<Scalars['Long']['output']>;
  variance_account_count?: Maybe<Scalars['Long']['output']>;
};

/**
 * Status of a remittance tape upload in loan-service.
 * Source: loan-management/loan-service/internal/model/remittance.go RemittancesUploadStatus.
 */
export enum RemittancesUploadStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type RemoveCollateralFileRequest = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  loanID: Scalars['ID']['input'];
};

export type RemoveCollateralFileResponse = {
  message: Scalars['String']['output'];
};

export type RemoveWireDetailsFileInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type RemoveWireDetailsFileResponse = {
  message: Scalars['String']['output'];
};

/** SSO Discovery Result */
export type SsoDiscoveryResult = {
  /** Cognito authorization endpoint base URL (e.g., https://mydomain.auth.us-east-1.amazoncognito.com/oauth2/authorize) */
  cognitoAuthorizationEndpoint?: Maybe<Scalars['String']['output']>;
  /** Cognito app client ID */
  cognitoClientId?: Maybe<Scalars['String']['output']>;
  hasSso: Scalars['Boolean']['output'];
  /** Identity provider name to use (for identity_provider parameter) */
  identityProvider?: Maybe<Scalars['String']['output']>;
  loginMethod: LoginMethod;
  /** Scopes to request (space-separated) */
  scope?: Maybe<Scalars['String']['output']>;
};

export type Sale = {
  /**
   * When the sale stops taking new access requests. Approvals, Level 2 grants and an approved
   * bidder's access run past it, through the sale's last bid deadline.
   */
  access_cutoff_at: Scalars['DateTime']['output'];
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  /** Who approved the sale. Null until approveSale has run, as is approved_at. */
  approved_by_user_id?: Maybe<Scalars['ID']['output']>;
  /**
   * The number of documents stored for the sale when it was approved. Null also on a sale approved
   * before approvals counted them. It can exceed the number saleDocuments lists, which leaves out a
   * document whose offering is not live or has no sale key, or whose loan is not in its offering.
   */
  approved_document_count?: Maybe<Scalars['Int']['output']>;
  /** As-of date of the offerings' Book Values. */
  calculation_date: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  /** Set only on a FAILED sale. */
  failure_reason?: Maybe<Scalars['String']['output']>;
  /** The offerings built so far. */
  offering_ids: Array<Scalars['ID']['output']>;
  rounds: Array<SaleRound>;
  sale_id: Scalars['ID']['output'];
  sale_keys: Array<Scalars['String']['output']>;
  sale_name: Scalars['String']['output'];
  selected_pool_ids: Array<Scalars['ID']['output']>;
  status: SaleStatus;
  updated_at: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type SaleAccess = {
  /** When the sale stops taking new access requests; null unless approved. Your level runs past it. */
  access_cutoff_at?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Every version of every sale document you have acknowledged for your company, by document type
   * and then version; empty when there are none. Not a grant: use level.
   */
  acknowledgements: Array<SaleAcknowledgement>;
  /** The sale is open and your company is an approved bidder. */
  approved: Scalars['Boolean']['output'];
  /** The sale's download period in hours; the default until approved. */
  download_period_hours: Scalars['Int']['output'];
  /**
   * What you may see now; null means no access, including once the sale's last bid deadline has
   * passed. The access cut-off does not end it. Any level needs an approved company and your
   * confidentiality agreement and PEC summary.
   */
  level?: Maybe<SaleBidderLevel>;
  sale_id: Scalars['ID']['output'];
  /** Your company's access request; null when it has not made one. */
  status?: Maybe<SaleBidderStatus>;
};

/** One version of a sale document you acknowledged. */
export type SaleAcknowledgement = {
  /** When you first acknowledged this version, in epoch milliseconds. */
  accepted_at_milliseconds: Scalars['Long']['output'];
  doc_type: SaleDocumentType;
  version: Scalars['String']['output'];
};

/** One version of a sale document's text, as acknowledgeSaleDocument records it. */
export type SaleAcknowledgementDocument = {
  doc_type: SaleDocumentType;
  /** The lowercase hex SHA-256 of text as UTF-8; send it as acknowledgeSaleDocument's document_sha256. */
  document_sha256: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** What the person executing a sale's CA states they are to the bidder. */
export enum SaleAcknowledgementRelationship {
  /** Employee of the bidder. */
  EMPLOYEE = 'EMPLOYEE',
  /** Third-party affiliate of the bidder. */
  THIRD_PARTY_AFFILIATE = 'THIRD_PARTY_AFFILIATE'
}

/** A sale as a company other than its seller sees it. It carries no company or user IDs. */
export type SaleAnnouncement = {
  /**
   * When the sale stops taking new access requests. Approvals, Level 2 grants and an approved
   * bidder's access run past it, through the sale's last bid deadline.
   */
  access_cutoff_at: Scalars['DateTime']['output'];
  /** The caller's company's access level; null unless `bidder_status` is APPROVED. */
  bidder_level?: Maybe<SaleBidderLevel>;
  /** Status of the caller's company's request to bid; null when it has made none. */
  bidder_status?: Maybe<SaleBidderStatus>;
  calculation_date: Scalars['DateTime']['output'];
  download_period_hours: Scalars['Int']['output'];
  /** One offering per selected pool. */
  offering_count: Scalars['Int']['output'];
  rounds: Array<SaleAnnouncementRound>;
  sale_id: Scalars['ID']['output'];
  /** The sale's public identifiers, as on the RFP's announcements. */
  sale_keys: Array<Scalars['String']['output']>;
  sale_name: Scalars['String']['output'];
  status: SaleStatus;
};

export type SaleAnnouncementRound = {
  deadline_at: Scalars['DateTime']['output'];
  /** True when the round is open to every approved bidder or names the caller's company. */
  invited: Scalars['Boolean']['output'];
  round: Scalars['Int']['output'];
};

export type SaleBid = {
  amount_cents?: Maybe<Scalars['Long']['output']>;
  bid_id: Scalars['ID']['output'];
  buyer_company_id: Scalars['ID']['output'];
  offering_ids: Array<Scalars['ID']['output']>;
  pct_e4?: Maybe<Scalars['Int']['output']>;
  /**
   * One per offering in offering_ids, labelled as saleBids reads the bid: a bidder keeps seeing which
   * pools it bid on after its access to saleOfferings ends at the deadline.
   */
  pools: Array<SaleBidPool>;
  received_at: Scalars['DateTime']['output'];
  round: Scalars['Int']['output'];
  sale_id: Scalars['ID']['output'];
  structure: SaleBidStructure;
  version: Scalars['Int']['output'];
};

export type SaleBidDraft = {
  amount_cents?: Maybe<Scalars['Long']['output']>;
  offering_ids: Array<Scalars['ID']['output']>;
  pct_e4?: Maybe<Scalars['Int']['output']>;
  round: Scalars['Int']['output'];
  sale_id: Scalars['ID']['output'];
  saved_at: Scalars['DateTime']['output'];
  structure: SaleBidStructure;
};

/** A stored run of the bid optimizer. Its results are in saleBidReport. */
export type SaleBidOptimizationRun = {
  round: Scalars['Int']['output'];
  sale_id: Scalars['ID']['output'];
  /** From 1 within the round. Send it as saleBidReport's `version`. */
  version: Scalars['Int']['output'];
};

/**
 * An offering of a bid, by its labels alone. A label is null when the sale has no live offering of
 * that ID, and on a submitSaleBid answer, which loan-service sends unlabelled.
 */
export type SaleBidPool = {
  fdic_pool_number?: Maybe<Scalars['String']['output']>;
  offering_id: Scalars['ID']['output'];
  offering_name?: Maybe<Scalars['String']['output']>;
};

export type SaleBidReport = {
  /** The .xlsx file, in standard base64. */
  content_base64: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  /** Carries the round and the run's version. */
  file_name: Scalars['String']['output'];
};

/** How a bidder proposes to pay: cash, or a joint venture transaction. */
export enum SaleBidStructure {
  CASH = 'CASH',
  JVT = 'JVT'
}

/** A company's request for access to an FDIC sale. */
export type SaleBidder = {
  buyer_company_id: Scalars['ID']['output'];
  company_name: Scalars['String']['output'];
  /**
   * Every decision on this bidder and every ORSNN vetting sign-off, oldest first. Seller only, and
   * only a user with the deal_manager role: anyone else, the bidder itself included, gets an error
   * and null here.
   */
  events?: Maybe<Array<SaleBidderEvent>>;
  /** The level the seller granted; null until approved. */
  level?: Maybe<SaleBidderLevel>;
  requested_at: Scalars['DateTime']['output'];
  sale_id: Scalars['ID']['output'];
  status: SaleBidderStatus;
  /** Send it back as decideSaleBidder's expected_version. */
  version: Scalars['Int']['output'];
  /**
   * When ORSNN recorded this bidder's vetting as complete; null until then, and null again once the
   * bidder is revoked or a REMOVE_L2 withdraws it. GRANT_L2 needs it.
   */
  vetting_completed_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A seller's decision on a bidder. */
export enum SaleBidderAction {
  APPROVE = 'APPROVE',
  GRANT_L2 = 'GRANT_L2',
  REJECT = 'REJECT',
  /**
   * Once the FDIC reports a bidder's security deposit returned: takes an APPROVED bidder at L2, or at
   * L1 holding ORSNN's vetting sign-off, to L1 without the sign-off, and withdraws the sign-off of a
   * PENDING bidder holding one, which stays PENDING. Either way the bidder keeps its standing, and L2
   * needs a fresh sign-off. Needs a note.
   */
  REMOVE_L2 = 'REMOVE_L2',
  REVOKE = 'REVOKE'
}

/** One change to a bidder's standing in a sale. */
export type SaleBidderEvent = {
  action: SaleBidderEventAction;
  /** "ORSNN operator" when ORSNN acted; otherwise that user's name, empty if there is no such user. */
  actor_name: Scalars['String']['output'];
  /**
   * The ORSNN operator who acted, by sign-in email: on VETTING_COMPLETE, and on a REMOVE_L2 ORSNN
   * took.
   */
  actor_operator_email?: Maybe<Scalars['String']['output']>;
  /** The user of your company who decided; null when ORSNN acted. */
  actor_user_id?: Maybe<Scalars['ID']['output']>;
  /** On a REVOKE or REMOVE_L2 of a vetted bidder: when the sign-off it withdrew was recorded. */
  cleared_vetting_completed_at?: Maybe<Scalars['DateTime']['output']>;
  /**
   * loan-service's codes for the checks ORSNN recorded; VETTING_COMPLETE only, and null on a sign-off
   * recorded without them. Not a closed set.
   */
  evidence_items?: Maybe<Array<Scalars['String']['output']>>;
  /** Null until the bidder is first approved. VETTING_COMPLETE changes neither status nor level. */
  from_level?: Maybe<SaleBidderLevel>;
  from_status: SaleBidderStatus;
  /**
   * What ORSNN checked, in its own words, on VETTING_COMPLETE; the FDIC notice it acted on, on
   * REMOVE_L2.
   */
  note?: Maybe<Scalars['String']['output']>;
  occurred_at: Scalars['DateTime']['output'];
  to_level?: Maybe<SaleBidderLevel>;
  to_status: SaleBidderStatus;
  /** The bidder's version once this event was recorded. */
  version: Scalars['Int']['output'];
  /** Where to find the FDIC's waiver decision that stood in for VETTED; VETTING_COMPLETE only. */
  waiver_reference?: Maybe<Scalars['String']['output']>;
};

/**
 * What a SaleBidderEvent records: one of SaleBidderAction's decisions, or ORSNN's sign-off that the
 * bidder's vetting is complete.
 */
export enum SaleBidderEventAction {
  APPROVE = 'APPROVE',
  GRANT_L2 = 'GRANT_L2',
  REJECT = 'REJECT',
  REMOVE_L2 = 'REMOVE_L2',
  REVOKE = 'REVOKE',
  VETTING_COMPLETE = 'VETTING_COMPLETE'
}

/** A bidder's sale access: L1 is inquiry, L2 is full due diligence. */
export enum SaleBidderLevel {
  L1 = 'L1',
  L2 = 'L2'
}

/** A bidder company's standing in a sale. Only APPROVED grants access; REJECTED is final. */
export enum SaleBidderStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  REVOKED = 'REVOKED'
}

export type SaleCreationJob = Job & {
  created_at: Scalars['Long']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  estimated_count: Scalars['Int']['output'];
  job_id: Scalars['ID']['output'];
  job_type: JobType;
  processed_count: Scalars['Int']['output'];
  progress_percentage: Scalars['Int']['output'];
  /** Set by createSale and saleCreationJob; null in job lists, which do not carry it. */
  sale_id?: Maybe<Scalars['ID']['output']>;
  started_at?: Maybe<Scalars['Long']['output']>;
  status: JobStatusEnum;
  updated_at: Scalars['Long']['output'];
};

/** The sale's own folder. */
export type SaleDataRoom = {
  documents: Array<SaleDataRoomDocument>;
  folder_name: Scalars['String']['output'];
  sale_id: Scalars['ID']['output'];
  sale_keys: Array<SaleDataRoomSaleKey>;
};

export type SaleDataRoomAsset = {
  documents: Array<SaleDataRoomDocument>;
  folder_name: Scalars['String']['output'];
  loan_id: Scalars['ID']['output'];
};

export type SaleDataRoomDocument = {
  /** loan-service's document type code, such as NARR or NOTE. Not a closed set. */
  doc_type: Scalars['String']['output'];
  document_id: Scalars['ID']['output'];
  file_name: Scalars['String']['output'];
  /** The bidder level the document requires. */
  level: SaleBidderLevel;
};

export type SaleDataRoomPool = {
  /** Empty for an L1 bidder: an asset's documents are all L2. */
  assets: Array<SaleDataRoomAsset>;
  documents: Array<SaleDataRoomDocument>;
  folder_name: Scalars['String']['output'];
  offering_id: Scalars['ID']['output'];
};

export type SaleDataRoomSaleKey = {
  folder_name: Scalars['String']['output'];
  pools: Array<SaleDataRoomPool>;
  sale_key: Scalars['String']['output'];
};

export enum SaleDocumentType {
  /** The sale's Confidentiality Agreement; taken while the sale is open, through its last bid deadline. */
  CA = 'CA',
  /**
   * The summary Purchaser Eligibility Certification; taken while the sale is open, through its last
   * bid deadline.
   */
  PEC_SUMMARY = 'PEC_SUMMARY',
  /**
   * Unused; do not send it. Nothing reads an acknowledgement of this type: the Special PII Notice is
   * accepted on each createProtectedDownload request instead (piiNoticeAcknowledged).
   * @deprecated Send piiNoticeAcknowledged on createProtectedDownload instead
   */
  PII_NOTICE = 'PII_NOTICE',
  /**
   * The notice on bidding on summary-level information, which a bidder approved at L1 needs before
   * bidding; taken while the current round takes bids, after the CA and the PEC summary.
   */
  SUMMARY_BID_NOTICE = 'SUMMARY_BID_NOTICE'
}

/**
 * One offering of an FDIC sale with its pool analytics. As on Listing, rates are in basis points and
 * money in cents.
 */
export type SaleOfferingView = {
  asset_class: AssetClass;
  /** UPB. This and the weighted averages below are null until cashflows has summarised the offering. */
  current_balance_cents?: Maybe<Scalars['Long']['output']>;
  fdic_pool_number: Scalars['String']['output'];
  loan_count: Scalars['Int']['output'];
  offering_id: Scalars['ID']['output'];
  offering_name: Scalars['String']['output'];
  /** Null on an offering built before the sale job stored its totals. */
  performance_totals?: Maybe<PerformanceTotals>;
  wa_age_months?: Maybe<Scalars['Int']['output']>;
  wa_borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  wa_coupon_bps?: Maybe<Scalars['Int']['output']>;
  wa_dti_bps?: Maybe<Scalars['Int']['output']>;
  wa_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
};

/**
 * A loan of an FDIC sale pool as the loan table shows it. Money is in cents, rates and ratios in
 * basis points, dates in Unix seconds. The fields from asset_name on are PII: null below L2.
 */
export type SalePoolLoan = {
  /** The 4C Asset ID. */
  account_id: Scalars['String']['output'];
  age_months: Scalars['Int']['output'];
  asset_class: AssetClass;
  asset_name?: Maybe<Scalars['String']['output']>;
  auto_vin?: Maybe<Scalars['String']['output']>;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  borrower_name?: Maybe<Scalars['String']['output']>;
  borrower_revolving_debt_cents?: Maybe<Scalars['Long']['output']>;
  borrower_summary?: Maybe<Scalars['String']['output']>;
  borrower_type?: Maybe<Scalars['String']['output']>;
  collateral_name?: Maybe<Scalars['String']['output']>;
  collateral_summary?: Maybe<Scalars['String']['output']>;
  current_balance_cents: Scalars['Long']['output'];
  days_past_due?: Maybe<Scalars['Int']['output']>;
  dti_bps?: Maybe<Scalars['Int']['output']>;
  first_payment_date_seconds: Scalars['Long']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  guarantor_names?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps: Scalars['Int']['output'];
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months: Scalars['Int']['output'];
  ltv_bps?: Maybe<Scalars['Int']['output']>;
  maturity_date_seconds?: Maybe<Scalars['Long']['output']>;
  next_payment_date_seconds?: Maybe<Scalars['Long']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date_seconds?: Maybe<Scalars['Long']['output']>;
  performance_status?: Maybe<PerformanceStatus>;
  product?: Maybe<Scalars['String']['output']>;
  property_description?: Maybe<Scalars['String']['output']>;
  remaining_loan_terms_months: Scalars['Int']['output'];
  sale_key?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type SalePoolLoanPage = {
  /** The fields salePoolLoans may be filtered by at this level. */
  allowed_filter_fields: Array<FilterableField>;
  /** The fields salePoolLoans may be sorted by at this level. */
  allowed_sort_fields: Array<SortableField>;
  /** The fields salePoolLoanTerms lists the values of at this level. */
  allowed_term_fields: Array<FilterableField>;
  level: SaleBidderLevel;
  loans: Array<SalePoolLoan>;
  /** Every loan in the pool that matches the filters, whatever the page. */
  total_count: Scalars['Int']['output'];
};

export type SalePoolLoanSort = {
  direction?: InputMaybe<SortDirection>;
  /** One of the page's allowed_sort_fields. */
  field: SortableField;
};

export enum SalePoolLoanTableEventKind {
  CONTEXT_MENU = 'CONTEXT_MENU',
  COPY = 'COPY',
  CUT = 'CUT'
}

/** What the client stamps on the loan table, and the view it opens with the key service. */
export type SalePoolLoanTableSession = {
  /**
   * When the view stops opening: an hour away, or the end of the bidder's access if sooner. Null for
   * the seller.
   */
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  level: SaleBidderLevel;
  offering_name: Scalars['String']['output'];
  /**
   * When api answered, on its own clock: the time the seller's watermark shows. A bidder's watermark
   * shows the key service's openedAt from /view instead.
   */
  opened_at: Scalars['DateTime']['output'];
  pool_number: Scalars['String']['output'];
  /** Whether the view is registered with IRM; false for the seller. */
  protected: Scalars['Boolean']['output'];
  sale_key: Scalars['String']['output'];
  /** The IRM view to open with the key service's /view. Null for the seller. */
  view_id?: Maybe<Scalars['ID']['output']>;
  viewer_name: Scalars['String']['output'];
};

/** One stored valuation of a sale's pool. Money is in cents. */
export type SalePoolValuation = {
  book_value_cents: Scalars['Long']['output'];
  /** The sale's as-of date for Book Value, in epoch seconds. */
  calculation_date_seconds: Scalars['Long']['output'];
  /** A decimal annual yield: 0.081 is 8.1%. */
  discount_yield?: Maybe<Scalars['Float']['output']>;
  fdic_pool_number: Scalars['String']['output'];
  loan_count: Scalars['Int']['output'];
  /** "model" or "proxy". */
  method?: Maybe<Scalars['String']['output']>;
  model_version?: Maybe<Scalars['String']['output']>;
  offering_id: Scalars['ID']['output'];
  /** In percent: 95.12 is 95.12% of Book Value. */
  pct_of_book_value?: Maybe<Scalars['Float']['output']>;
  pool_id: Scalars['ID']['output'];
  value_cents: Scalars['Long']['output'];
  valued_at_milliseconds: Scalars['Long']['output'];
  /** From 1 within the pool; a rerun is the next version. */
  version: Scalars['Int']['output'];
};

export type SaleReviewerAccess = {
  active: Scalars['Boolean']['output'];
};

/** The part a company plays in a sale. */
export enum SaleRole {
  BIDDER = 'BIDDER',
  SELLER = 'SELLER'
}

export type SaleRound = {
  deadline_at: Scalars['DateTime']['output'];
  /** Empty means every approved bidder. */
  invited_company_ids: Array<Scalars['ID']['output']>;
  round: Scalars['Int']['output'];
};

/** Where a sale is in its creation. FAILED is terminal. Not the bidding phase. */
export enum SaleStatus {
  CREATING = 'CREATING',
  FAILED = 'FAILED',
  OPEN = 'OPEN',
  /** Built, and waiting for approveSale; only its seller sees it. */
  PENDING_APPROVAL = 'PENDING_APPROVAL'
}

/** A sale as one company sees it: `Sale` for its seller, `SaleAnnouncement` for anyone else. */
export type SaleView = Sale | SaleAnnouncement;

export type SaveSaleBidDraftInput = {
  amount_cents?: InputMaybe<Scalars['Long']['input']>;
  /** One offering is a single bid; several are one linked, all-or-none bid. Order does not matter. */
  offering_ids: Array<Scalars['ID']['input']>;
  /** As on SubmitSaleBidInput: exactly one of pct_e4 and amount_cents. */
  pct_e4?: InputMaybe<Scalars['Int']['input']>;
  round: Scalars['Int']['input'];
  sale_id: Scalars['ID']['input'];
  structure: SaleBidStructure;
};

export type SaveSellerBidInput = {
  bid_id: Scalars['ID']['input'];
  deal_id: Scalars['ID']['input'];
  seller_bid_basis_points: Scalars['Float']['input'];
  transfer_amount?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveWireDetailsPricesInput = {
  cleanPriceCents?: InputMaybe<Scalars['Long']['input']>;
  dealID: Scalars['ID']['input'];
  dirtyPriceCents?: InputMaybe<Scalars['Long']['input']>;
};

export type SelectDiligenceLoansInput = {
  deal_id: Scalars['ID']['input'];
  loan_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  selection_filters?: InputMaybe<Array<Filter>>;
};

export type SentWireTransferInput = {
  deal_id: Scalars['ID']['input'];
};

export enum ServicingPreference {
  NONE = 'NONE',
  RELEASED = 'RELEASED',
  RETAINED = 'RETAINED'
}

/** Input for setRemittanceWireDetails. Omitted fields are left untouched; providing a field overwrites the entire buyer or seller wire details map. */
export type SetRemittanceWireDetailsInput = {
  /** When provided, sets the buyer remittances received flag. Wire detail updates are rejected if this flag is already true. */
  buyer_remittances_received?: InputMaybe<Scalars['Boolean']['input']>;
  buyer_wire_details?: InputMaybe<WireDetailsInput>;
  /** ID of the deal */
  deal_id: Scalars['ID']['input'];
  /** Current version of the item for optimistic locking */
  existing_version: Scalars['Int']['input'];
  /** Payment month in YYYY-MM format */
  payment_month: Scalars['String']['input'];
  /** When provided, sets the seller remittances sent flag. */
  seller_remittances_sent?: InputMaybe<Scalars['Boolean']['input']>;
  seller_wire_details?: InputMaybe<WireDetailsInput>;
};

export type SetWireDetailsPricesVisibleInput = {
  dealID: Scalars['ID']['input'];
};

export type Setting = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SettlementCard = TimelineCard & {
  deal: Deal;
  /** SettlementCard Fields */
  is_complete: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  /** This will not return prices if the seller has not made them visible */
  prices?: Maybe<PriceItem>;
  role: DealRole;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

export type SingleCollateralFileMetadataInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  loanID: Scalars['ID']['input'];
};

export type SingleCollateralFileMetadataResponse = {
  file?: Maybe<FileItem>;
};

export type Sort = {
  sort_direction?: InputMaybe<SortDirection>;
  sort_field?: InputMaybe<SortableField>;
};

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum SortableField {
  account_id = 'account_id',
  age_months = 'age_months',
  asset_class = 'asset_class',
  auto_original_value_cents = 'auto_original_value_cents',
  bankruptcy = 'bankruptcy',
  borrower_credit_score = 'borrower_credit_score',
  charge_off = 'charge_off',
  /**
   * MARINE fields (ENG-2961). cashflows sorts these via SortableField::Charter /
   * DealerReserveCents / DealerReserveBps (ENG-2972). Deploy cashflows first.
   */
  charter = 'charter',
  city = 'city',
  current_balance_cents = 'current_balance_cents',
  days_past_due = 'days_past_due',
  dealer_reserve_bps = 'dealer_reserve_bps',
  dealer_reserve_cents = 'dealer_reserve_cents',
  /**
   * DSCR / Non-QM subtype (ENG-2859). Sortable for the DSCR grid column; cashflows
   * sorts it via SortableField::DscrBps (non-DSCR loans sort as 0). Deploy cashflows first.
   */
  dscr_bps = 'dscr_bps',
  dti_bps = 'dti_bps',
  first_payment_date_seconds = 'first_payment_date_seconds',
  first_rate_change_date_seconds = 'first_rate_change_date_seconds',
  fund_number = 'fund_number',
  institution_id = 'institution_id',
  interest_cents = 'interest_cents',
  interest_rate_bps = 'interest_rate_bps',
  last_updated_date_seconds = 'last_updated_date_seconds',
  loan_number = 'loan_number',
  loan_terms_months = 'loan_terms_months',
  ltv_bps = 'ltv_bps',
  maturity_date_seconds = 'maturity_date_seconds',
  next_payment_date_seconds = 'next_payment_date_seconds',
  original_balance_cents = 'original_balance_cents',
  origination_date_seconds = 'origination_date_seconds',
  payment_cents = 'payment_cents',
  performance_status = 'performance_status',
  postal_code = 'postal_code',
  principal_cents = 'principal_cents',
  product = 'product',
  remaining_loan_terms_months = 'remaining_loan_terms_months',
  /** FDIC loan fields, sorted by cashflows. asset_name is left out: it is PII. */
  sale_key = 'sale_key',
  servicing_rate_bps = 'servicing_rate_bps',
  starting_balance_cents = 'starting_balance_cents',
  state = 'state',
  tdr = 'tdr'
}

/** One version of the Special PII Notice's text. A version's text never changes. */
export type SpecialPiiNotice = {
  /** The lowercase hex SHA-256 of text as UTF-8. */
  document_sha256: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum Status {
  ARCHIVED = 'ARCHIVED',
  LIVE = 'LIVE'
}

/** Types of stipulations a buyer can save to their carve */
export enum StipulationFieldName {
  bid_basis_points = 'bid_basis_points',
  diligence_completion_date_seconds = 'diligence_completion_date_seconds',
  min_net_yield_to_buyer_bps = 'min_net_yield_to_buyer_bps',
  percent_collateral_diligence_bps = 'percent_collateral_diligence_bps',
  servicing_rate_bps = 'servicing_rate_bps',
  settlement_date_seconds = 'settlement_date_seconds',
  transfer_amount = 'transfer_amount'
}

export enum StipulationToggleName {
  has_diligence_completion_date_seconds = 'has_diligence_completion_date_seconds',
  has_min_net_yield_to_buyer = 'has_min_net_yield_to_buyer',
  has_percent_collateral_diligence = 'has_percent_collateral_diligence',
  has_settlement_date_seconds = 'has_settlement_date_seconds',
  is_servicing_retained = 'is_servicing_retained'
}

export type Stipulations = {
  bid_basis_points?: Maybe<Scalars['Int']['output']>;
  custom_stipulations?: Maybe<Array<Scalars['String']['output']>>;
  diligence_completion_date_seconds?: Maybe<Scalars['Int']['output']>;
  has_diligence_completion_date_seconds?: Maybe<Scalars['Boolean']['output']>;
  has_min_net_yield_to_buyer?: Maybe<Scalars['Boolean']['output']>;
  has_percent_collateral_diligence?: Maybe<Scalars['Boolean']['output']>;
  has_settlement_date_seconds?: Maybe<Scalars['Boolean']['output']>;
  is_servicing_retained?: Maybe<Scalars['Boolean']['output']>;
  min_net_yield_to_buyer_bps?: Maybe<Scalars['Int']['output']>;
  percent_collateral_diligence_bps?: Maybe<Scalars['Int']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  settlement_date_seconds?: Maybe<Scalars['Int']['output']>;
  transfer_amount?: Maybe<Scalars['Int']['output']>;
};

/** A single strat row bucket.  The key identifies which strat bucket the row belongs to. There are also three types of columns: totals, percents, and weighted averages.  All weighted averages are weighted by current balance against the whole selection of loans. */
export type StratRow = {
  key: Scalars['String']['output'];
  t_count: Scalars['Int']['output'];
  t_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  t_original_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_age_months?: Maybe<Scalars['Float']['output']>;
  wa_borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  /**
   * Weighted-average Combined LTV (CLTV) in basis points. HELOC-only — zero
   * on non-HELOC strats since combined_ltv_bps is None on those loans.
   */
  wa_combined_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_coupon_bps?: Maybe<Scalars['Int']['output']>;
  wa_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  /**
   * Weighted-average HELOC draw / repayment period in months. HELOC-only —
   * zero on non-HELOC strats since these fields are None on those loans.
   * wa_remaining_draw_period_months is the HELOC-only balance-weighted
   * (draw - age) — the renderable Draw → Repayment phase boundary.
   */
  wa_draw_period_months?: Maybe<Scalars['Float']['output']>;
  wa_dti_bps?: Maybe<Scalars['Int']['output']>;
  wa_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_net_rate?: Maybe<Scalars['Float']['output']>;
  wa_net_rate_bps?: Maybe<Scalars['Int']['output']>;
  wa_original_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_remaining_draw_period_months?: Maybe<Scalars['Float']['output']>;
  wa_remaining_loan_terms_months?: Maybe<Scalars['Float']['output']>;
  wa_repayment_period_months?: Maybe<Scalars['Float']['output']>;
};

export type StratificationsCard = TimelineCard & {
  /** StratificationsCard Fields */
  allow_filtering: Scalars['Boolean']['output'];
  asset_class: AssetClass;
  deal: Deal;
  last_updated_date: Scalars['DateTime']['output'];
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
};

export type SubmitBidInput = {
  bid_basis_points: Scalars['Int']['input'];
  /**
   * Stipulations are copied to the bid when the bid is submitted. We must submit a carve_id to copy the stipulations so this is
   * now required.
   */
  carve_id: Scalars['ID']['input'];
  deal_id: Scalars['ID']['input'];
  /** This may be required in the future. */
  document_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SubmitReferralInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SubmitSaleBidInput = {
  amount_cents?: InputMaybe<Scalars['Long']['input']>;
  /** Ignored: a series takes one bid. */
  expected_version?: InputMaybe<Scalars['Int']['input']>;
  /** One offering is a single bid; several are one linked, all-or-none bid. Order does not matter. */
  offering_ids: Array<Scalars['ID']['input']>;
  /**
   * Percent of the offerings' combined Book Value × 10^4: 62.3456% is 623456. Exactly one of
   * pct_e4 and amount_cents.
   */
  pct_e4?: InputMaybe<Scalars['Int']['input']>;
  round: Scalars['Int']['input'];
  sale_id: Scalars['ID']['input'];
  structure: SaleBidStructure;
};

/** Input for submitting a support request */
export type SubmitSupportRequestInput = {
  /** User's description of the issue */
  description: Scalars['String']['input'];
  /** Additional metadata about the issue */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Session ID from the client logger to correlate user activity */
  sessionId: Scalars['String']['input'];
  /** URL where the issue occurred (optional, will be extracted from request if not provided) */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Response from submitting a support request */
export type SubmitSupportRequestResponse = {
  /** Status message */
  message?: Maybe<Scalars['String']['output']>;
  /** Unique ID for the support request */
  requestId: Scalars['ID']['output'];
};

/** Tapestry: full status of a file processing job (stub). */
export type TapestryJobStatus = {
  classification: TapestryStageStatus;
  /** User-facing banner text for terminal states; null while in progress or on success with persists. */
  completion_message?: Maybe<Scalars['String']['output']>;
  /**
   * Terminal routing key: in_progress | success | success_no_persist | no_records |
   * validation_error | pipeline_failed | cancelled | rejected
   */
  completion_outcome: Scalars['String']['output'];
  current_stage: Scalars['String']['output'];
  decomposition: TapestryStageStatus;
  detection: TapestryStageStatus;
  extraction: TapestryStageStatus;
  file_id: Scalars['ID']['output'];
  /** Single 0–100 progress bar for the full pipeline (stage-weighted when processing_percent unset). */
  overall_progress: Scalars['Int']['output'];
  persistence: TapestryStageStatus;
  /** Human review gate; use ready_for_review for Confirm CTA, not File.state alone. */
  review: TapestryStageStatus;
  validation: TapestryStageStatus;
};

/** Tapestry: status of a single processing stage (stub). */
export type TapestryStageStatus = {
  error_message?: Maybe<Scalars['String']['output']>;
  errors_count?: Maybe<Scalars['Int']['output']>;
  fields_mapped?: Maybe<Scalars['Int']['output']>;
  loans_classified?: Maybe<Scalars['Int']['output']>;
  loans_persisted?: Maybe<Scalars['Int']['output']>;
  loans_validated?: Maybe<Scalars['Int']['output']>;
  progress_percentage: Scalars['Int']['output'];
  ready_for_review?: Maybe<Scalars['Boolean']['output']>;
  regions_detected?: Maybe<Scalars['Int']['output']>;
  rows_processed?: Maybe<Scalars['Int']['output']>;
  sheets_processed?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  timing?: Maybe<TapestryStageTiming>;
};

/** Tapestry: timing for a processing stage (stub). */
export type TapestryStageTiming = {
  completed_at: Scalars['DateTime']['output'];
  started_at: Scalars['DateTime']['output'];
};

export type TermsDocument = {
  documentSizeBytes: Scalars['Int']['output'];
  /**
   * Presigned download link. Null for a document of an FDIC-sale offering, which is released only
   * as a protected download.
   */
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_template: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** TermsDocument fields */
  selected: Scalars['Boolean']['output'];
  type: FileType;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<DocumentUploader>;
};

export type TimelineCard = {
  deal: Deal;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type TimelineStage = {
  calls_to_action: Array<CallToAction>;
  status: TimelineStatus;
  subject: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum TimelineStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ToggleStipulationInput = {
  buyer_company_id: Scalars['ID']['input'];
  /** Stipulations are saved on a deal carve. When the carve is deleted, the stipulations are also deleted. */
  carve_id: Scalars['ID']['input'];
  /** We only support toggling stipulations listed in the enum */
  field_name: StipulationToggleName;
  /** Required for loan service integration to load carve correctly */
  offering_id: Scalars['ID']['input'];
  /** If the flag should be on or off */
  value: Scalars['Boolean']['input'];
};

/** Input for restoring multiple archived loan tapes */
export type UnarchiveLoanTapesInput = {
  /** IDs of the loan tapes (File records) to restore */
  tape_ids: Array<Scalars['ID']['input']>;
};

/**
 * How a residential loan was underwritten/documented (ENG-2825). A DSCR loan is
 * QMStatus NON_QM with underwritingType DSCR.
 */
export enum UnderwritingType {
  ASSET_UTIL = 'ASSET_UTIL',
  BANK_STATEMENT = 'BANK_STATEMENT',
  DOC_1099 = 'DOC_1099',
  DSCR = 'DSCR',
  FULL_DOC = 'FULL_DOC',
  OTHER = 'OTHER'
}

export type UnsecuredPersonalLoan = Loan & {
  account_id?: Maybe<Scalars['String']['output']>;
  age_months?: Maybe<Scalars['Int']['output']>;
  asset_class: AssetClass;
  borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  company: PrivateCompany;
  currency_code: Scalars['String']['output'];
  current_balance_cents: Scalars['Long']['output'];
  /**
   * ConsumerLoan specific (integer bps, e.g. 3036 = 30.36%); null for
   * asset-depletion loans (ENG-3391)
   */
  dti_bps?: Maybe<Scalars['Int']['output']>;
  first_payment_date: Scalars['DateTime']['output'];
  fund_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institution_id?: Maybe<Scalars['String']['output']>;
  interest_rate_bps?: Maybe<Scalars['Int']['output']>;
  last_loan_tape_id: Scalars['ID']['output'];
  last_loan_tape_name: Scalars['String']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  listing?: Maybe<Listing>;
  loan_number?: Maybe<Scalars['String']['output']>;
  loan_terms_months: Scalars['Int']['output'];
  maturity_date: Scalars['DateTime']['output'];
  next_payment_date?: Maybe<Scalars['DateTime']['output']>;
  original_balance_cents: Scalars['Long']['output'];
  origination_date: Scalars['DateTime']['output'];
  performance_status?: Maybe<PerformanceStatus>;
  /** Returns pools (loan collections) that contain this loan. */
  pools: Array<Listing>;
  product?: Maybe<Scalars['String']['output']>;
  /** Unsecured Personal Loan specific */
  purpose?: Maybe<Scalars['String']['output']>;
  remaining_loan_terms_months?: Maybe<Scalars['Int']['output']>;
  sale_key?: Maybe<Scalars['String']['output']>;
  servicing_rate_bps?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** ASSET_UTIL when the tape's asset_based_decision flag was truthy (ENG-3391) */
  underwriting_type?: Maybe<UnderwritingType>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type UpdateCollateralStatusInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  loanID: Scalars['ID']['input'];
  newStatus: CollateralStatus;
};

export type UpdateCustomStipulationsInput = {
  buyer_company_id: Scalars['ID']['input'];
  carve_id: Scalars['ID']['input'];
  custom_stipulations: Array<Scalars['String']['input']>;
  /** Required for loan service integration to load carve correctly */
  offering_id: Scalars['ID']['input'];
};

export type UpdateDealCarveInput = {
  carve?: InputMaybe<Array<Filter>>;
  carve_id: Scalars['ID']['input'];
  deal_id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updateRemittanceVarianceStatus: acknowledge or revert a specific variance with optimistic locking. */
export type UpdateRemittanceVarianceStatusInput = {
  account_id: Scalars['String']['input'];
  /** Current version of the variance item for optimistic locking. */
  expected_version: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: VarianceStatus;
  upload_id: Scalars['ID']['input'];
  variance_code: VarianceCode;
};

/** Response for updateRemittanceVarianceStatus. */
export type UpdateRemittanceVarianceStatusResponse = {
  item: RemittanceRecordVariance;
};

export type UpdateStipulationInput = {
  buyer_company_id: Scalars['ID']['input'];
  /** Stipulations are saved on a deal carve. When the carve is deleted, the stipulations are also deleted. */
  carve_id: Scalars['ID']['input'];
  /** We only support updating stipulations listed in the enum */
  field_name: StipulationFieldName;
  /** Required for loan service integration to load carve correctly */
  offering_id: Scalars['ID']['input'];
  /** Validation for data types are done on the backend */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum Uploader {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

export type User = {
  address?: Maybe<Scalars['String']['output']>;
  company: UserCompany;
  email: Scalars['String']['output'];
  family_name?: Maybe<Scalars['String']['output']>;
  filter_templates: Array<FilterTemplate>;
  given_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_used_mapping: Array<HeaderMap>;
  /** Company-level roles for the current user in their company. Used by the client to show/hide nav and features. */
  roles: Array<UserRole>;
  setting: Scalars['String']['output'];
  settings: Array<Setting>;
  title?: Maybe<Scalars['String']['output']>;
};


export type UserFilter_TemplatesArgs = {
  asset_class: AssetClass;
};


export type UserLast_Used_MappingArgs = {
  asset_class: AssetClass;
};


export type UserSettingArgs = {
  name: Scalars['String']['input'];
};


export type UserSettingsArgs = {
  names: Array<Scalars['String']['input']>;
};

export type UserCompany = Company & {
  /** UserCompany fields */
  account?: Maybe<Loan>;
  deals: Array<Deal>;
  documents: Array<Document>;
  employees: Array<User>;
  /** Returns a single file belonging to the company.  If the file doesn't exist, returns null. */
  file?: Maybe<File>;
  /** Only returns loan tapes, despite being named "files" due to legacy reasons */
  files: Array<File>;
  form5300LLMAnalysis?: Maybe<LoanData>;
  /** PrivateCompany fields */
  id: Scalars['ID']['output'];
  is_chat_enabled: Scalars['Boolean']['output'];
  /** Returns background jobs for the company with optional filtering by type and status */
  jobs: Array<Job>;
  listings: Array<Listing>;
  /** Returns a single loan belonging to the company. */
  loan?: Maybe<Loan>;
  /**
   * Loan tape upload history. Archived tapes are hidden by default; pass includeArchived: true
   * to surface them (e.g. behind a "Show archived" toggle). See ENG-2845.
   */
  loan_tapes: Array<File>;
  /** Returns a page of loans for listing purposes. sort and pagination are both required, and filters are optional.  Filters are ANDed together before applying to the loan list. */
  loans: Array<Loan>;
  name: Scalars['String']['output'];
  /** Returns offerings for the company. This is identical to listings but uses the new entity name for future loan service migration. */
  offerings: Array<Listing>;
  /** Filters are ANDed together before applying to the loan list and calculating the performance summary. */
  performance_summary: PerformanceSummary;
  /** Returns a specific pool (loan collection) by ID for the company. */
  pool?: Maybe<Pool>;
  /** Returns pools (loan collections) for the company. Pools are private collections of loans used for internal portfolio management. */
  pools: Array<Pool>;
  regulatory_agency?: Maybe<Agency>;
  regulatory_metrics?: Maybe<RegulatoryMetrics>;
  regulatory_number: Scalars['String']['output'];
  /** Remittance tape uploads for this company (seller only). Sorted by created_at desc. */
  remittance_tapes: Array<RemittanceTapeUpload>;
  short_name: Scalars['String']['output'];
  templates: Array<Document>;
  type: Scalars['String']['output'];
};


export type UserCompanyAccountArgs = {
  account_id: Scalars['String']['input'];
};


export type UserCompanyDealsArgs = {
  role?: InputMaybe<DealSide>;
};


export type UserCompanyDocumentsArgs = {
  fileType?: InputMaybe<FileType>;
};


export type UserCompanyFileArgs = {
  id: Scalars['ID']['input'];
};


export type UserCompanyJobsArgs = {
  job_type?: InputMaybe<JobType>;
  statuses?: InputMaybe<Array<JobStatusEnum>>;
};


export type UserCompanyLoanArgs = {
  id: Scalars['ID']['input'];
};


export type UserCompanyLoan_TapesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserCompanyLoansArgs = {
  filters?: InputMaybe<Array<Filter>>;
  pagination: Pagination;
  sort: Sort;
};


export type UserCompanyPerformance_SummaryArgs = {
  filters?: InputMaybe<Array<Filter>>;
};


export type UserCompanyPoolArgs = {
  id: Scalars['ID']['input'];
};


export type UserCompanyTemplatesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCompanyListing = Listing & {
  /** Flag determining if this deal can be marketed to banks. */
  allow_banks: Scalars['Boolean']['output'];
  /** Flag determining if this loan pool can be marketed to credit unions. */
  allow_credit_unions: Scalars['Boolean']['output'];
  /** Flag determining if this loan pool can be marketed to non depository institutions. */
  allow_private_capital: Scalars['Boolean']['output'];
  asset_class: AssetClass;
  company: Company;
  created_date: Scalars['DateTime']['output'];
  /** user company listing specific */
  deals: Array<Deal>;
  description?: Maybe<Scalars['String']['output']>;
  execution_type: ExecutionType;
  /** When the offering leaves the marketplace. Null for a pool-backed listing, which does not expire. */
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  has_cra?: Maybe<Scalars['Boolean']['output']>;
  /** Listing Implemented Fields */
  id: Scalars['ID']['output'];
  /** This field is the deal id in progress for the listing for the user's company */
  in_progress_deal_id?: Maybe<Scalars['String']['output']>;
  is_participation_negotiable?: Maybe<Scalars['Boolean']['output']>;
  is_public: Scalars['Boolean']['output'];
  is_servicing_negotiable?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date: Scalars['DateTime']['output'];
  loan_count?: Maybe<Scalars['Int']['output']>;
  minimum_carve_cents?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  /** Deal rooms still at the inquiry stage (SELLER_INQUIRY). */
  open_inquiry_count: Scalars['Int']['output'];
  origination_type: OriginationType;
  /** This field should be ignored if execution type is "all or nothing". */
  participation_rate?: Maybe<Scalars['Int']['output']>;
  performance_class: PerformanceClass;
  /** Both parties have full access to loan-level performance data. */
  performance_summary: PerformanceSummary;
  /** If the pricing_type is NONE, this will return null. */
  pricing_rate_bps?: Maybe<Scalars['Int']['output']>;
  pricing_type?: Maybe<PricingType>;
  /**
   * Deal rooms past inquiry: offer, diligence, settlement or complete. Rejected inquiries are
   * not counted.
   */
  progressed_room_count: Scalars['Int']['output'];
  provided_name?: Maybe<Scalars['String']['output']>;
  /**
   * The FDIC sale this offering is a pool of; null on a marketplace offering. Raw loan-data
   * exports are withheld for an offering in a sale.
   */
  sale_id?: Maybe<Scalars['ID']['output']>;
  servicing_fee_rate_bps?: Maybe<Scalars['Int']['output']>;
  servicing_preference?: Maybe<ServicingPreference>;
  state: ListingState;
  t_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  /** Template documents attached to the offering. */
  template_document_ids?: Maybe<Array<Scalars['ID']['output']>>;
  top_states?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Revision counter of the offering row. It moves on every write to the row, buyer deal-room
   * activity included.
   */
  version: Scalars['Int']['output'];
  wa_borrower_credit_score?: Maybe<Scalars['Int']['output']>;
  wa_coupon_bps?: Maybe<Scalars['Int']['output']>;
  wa_current_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_dti_bps?: Maybe<Scalars['Int']['output']>;
  wa_loan_age_months?: Maybe<Scalars['Int']['output']>;
  wa_ltv_bps?: Maybe<Scalars['Int']['output']>;
  wa_original_balance_cents?: Maybe<Scalars['Long']['output']>;
  wa_remaining_loan_terms_months?: Maybe<Scalars['Float']['output']>;
};


export type UserCompanyListingDealsArgs = {
  shouldSort?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserCompanyListingPerformance_SummaryArgs = {
  filters?: InputMaybe<Array<Filter>>;
};

/** Add the UserScope and UserEntity type definitions */
export enum UserEntity {
  company = 'company',
  listing = 'listing'
}

export type UserManagementAddUserScopeRequest = {
  companyID: Scalars['String']['input'];
  scopes: Array<UserScopeInput>;
  userID?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserManagementAddUserScopeResponse = {
  success: Scalars['Boolean']['output'];
};

export type UserManagementCreateUserRequest = {
  companyID: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  roles: Array<UserRole>;
  userEmail: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UserManagementCreateUserResponse = {
  success: Scalars['Boolean']['output'];
};

export type UserManagementGetUserRequest = {
  userID?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserManagementGetUserResponse = {
  permissions: Array<UserManagementPermission>;
  user: UserManagementUser;
};

export type UserManagementListCompanyPermissionsRequest = {
  companyID: Scalars['String']['input'];
};

export type UserManagementListCompanyPermissionsResponse = {
  permissions: Array<UserManagementPermission>;
};

export type UserManagementListCompanyUserPermissionsRequest = {
  companyID: Scalars['String']['input'];
};

export type UserManagementListCompanyUserPermissionsResponse = {
  userPermissions: Array<UserPermission>;
};

export type UserManagementPermission = {
  companyID: Scalars['String']['output'];
  principleID: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<UserRole>>>;
  scopes?: Maybe<Array<Maybe<UserScope>>>;
};

export type UserManagementRemoveUserFromCompanyRequest = {
  companyID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};

export type UserManagementRemoveUserFromCompanyResponse = {
  success: Scalars['Boolean']['output'];
};

export type UserManagementUpdateUserInfoRequest = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UserManagementUpdateUserInfoResponse = {
  success: Scalars['Boolean']['output'];
};

export type UserManagementUpdateUserRolesRequest = {
  companyID: Scalars['String']['input'];
  roles: Array<UserRole>;
  userID?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserManagementUpdateUserRolesResponse = {
  success: Scalars['Boolean']['output'];
};

export type UserManagementUpdateUserScopesRequest = {
  companyID: Scalars['String']['input'];
  scopes: Array<UserScopeInput>;
  userID?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserManagementUpdateUserScopesResponse = {
  success: Scalars['Boolean']['output'];
};

export type UserManagementUser = {
  companyID?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  lastLoginDate: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  userID?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type UserPermission = {
  permission: UserManagementPermission;
  user: UserManagementUser;
};

export type UserPreferences = {
  email: Scalars['String']['output'];
  emailOptIn: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  textOptIn: Scalars['Boolean']['output'];
  userID: Scalars['String']['output'];
};

export enum UserRole {
  authorized_signer = 'authorized_signer',
  deal_manager = 'deal_manager',
  deal_participant = 'deal_participant',
  diligence_reviewer = 'diligence_reviewer',
  marketplace_viewer = 'marketplace_viewer',
  portfolio_manager = 'portfolio_manager',
  portfolio_viewer = 'portfolio_viewer',
  remittances_manager = 'remittances_manager',
  remittances_viewer = 'remittances_viewer',
  user_administrator = 'user_administrator'
}

export type UserScope = {
  entity: UserEntity;
  id: Scalars['String']['output'];
  role: UserRole;
};

export type UserScopeInput = {
  entity: UserEntity;
  id: Scalars['String']['input'];
  role: UserRole;
};

export type ValidTermsResult = {
  fieldName: FilterableField;
  terms: Array<Scalars['String']['output']>;
};

/** Variance code identifying a specific anomaly type detected on a remittance record. */
export enum VarianceCode {
  BALANCE_EXCEEDS_ORIGINAL = 'BALANCE_EXCEEDS_ORIGINAL',
  BALANCE_INCREASED = 'BALANCE_INCREASED',
  DPD_OUT_OF_RANGE = 'DPD_OUT_OF_RANGE',
  DPD_REVERSED = 'DPD_REVERSED'
}

/** Review lifecycle status of a detected variance. */
export enum VarianceStatus {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  PENDING = 'PENDING'
}

export type WireConfirmationCard = TimelineCard & {
  company_id: Scalars['ID']['output'];
  deal: Deal;
  files_with_notes: Array<WireDetailsFile>;
  is_wire_sent: Scalars['Boolean']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  /** This will not return prices if the seller has not made them visible */
  prices?: Maybe<PriceItem>;
  /** TimelineCard Fields */
  title: Scalars['String']['output'];
  /** WireConfirmationCard Fields */
  user_id: Scalars['ID']['output'];
  user_role: DealMessageAuthorRole;
  wire_details?: Maybe<WireDetails>;
};

export type WireDetails = {
  account_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  bank_name: Scalars['String']['output'];
  routing_number: Scalars['String']['output'];
};

export type WireDetailsFile = {
  deal: Deal;
  fileName: Scalars['String']['output'];
  notes: Array<WireDetailsNote>;
  s3Key: Scalars['String']['output'];
};

export type WireDetailsFileDownloadUrlInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type WireDetailsFileDownloadUrlResponse = {
  URL: Scalars['String']['output'];
};

export type WireDetailsFileUploadUrlInput = {
  dealID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type WireDetailsFileUploadUrlResponse = {
  Metadata?: Maybe<Scalars['JSONObject']['output']>;
  URL: Scalars['String']['output'];
};

/** Wire details fields for input. */
export type WireDetailsInput = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  bank_name: Scalars['String']['input'];
  routing_number: Scalars['String']['input'];
};

export type WireDetailsNote = {
  authorCompany: Company;
  authorRole: DealMessageAuthorRole;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};
